import React, { useState, useEffect, useRef } from "react";
import Axios from "axios";
import "./../../../../assets/css/purchase/form.css";
import Select from "react-select";
import Swal from "sweetalert2";
// React DateTime
import Datetime from "react-datetime";
import moment from "moment";

// Components
import Breadcrumbs from "../../../components/Breadcrumbs";
import QtModal from "../../../components/Modal/QtModal";
import ArModal from "../../../components/Modal/ArModal";
import ItemTable from "../../../components/Content/ItemTable";
import Summary from "../../../components/Footer/Summary";
import FormAction from "../../../components/Actions/FormAction";
import PaymentModal from "../../../components/Modal/PaymentModal";

// Model
import { soMasterModel } from "../../../../model/SellProducts/SoMasterModel";
import { soDetailModel } from "../../../../model/SellProducts/SoDetailModel";

// Utils
import {
  getData,
  getDataWithComp,
  getByDocId,
  getDocType,
  getTransType,
  getAlert,
  formatCurrency,
  parseCurrency,
  deleteData,
  randomDelay,
  getDataWithJoin,
  getMaxInvNo,
  getMaxDsrNo,
  getMaxCsNo,
  createSetRecNo,
  getMaxRecNoForTest,
  updateData,
  insertData,
} from "../../../../utils/SamuiUtils";

import {
  formatStringDateToDate,
  formatDateOnChange,
  formatDateTime,
  formatThaiDateUi,
  formatThaiDateUiToDate,
  getCreateDateTime,
  setCreateDateTime,
  getCreateDateTime2,
} from "../../../../utils/DateUtils";

import { manageWhItemData } from "../../../../utils/WarehouseUtils";
import {
  manageWhArPaymentData,
  setRemarkByPaymentType,
} from "../../../../utils/PaymentUtils";

function Form({ callInitialize, mode, name, maxDocNo, getReport }) {
  // console.debug("maxDocNo", maxDocNo);
  const [formMasterList, setFormMasterList] = useState(soMasterModel());
  const [formDetailList, setFormDetailList] = useState([]);
  const [tbDocType, setTbDocType] = useState([]);
  const [tbTransType, setTbTransType] = useState([]);
  const [qtDataList, setQtDataList] = useState([]);
  const [arDataList, setArDataList] = useState([]);
  const [itemDataList, setItemDataList] = useState([]);
  const [whDataList, setWhDataList] = useState([]);
  const [saleman, setSalemanList] = useState([]);
  const [whid, setWhid] = useState(0);

  // การคำนวณเงิน
  const [selectedDiscountValueType, setSelectedDiscountValueType] =
    useState("1");
  const [totalPrice, setTotalPrice] = useState(0);
  const [receiptDiscount, setReceiptDiscount] = useState(0);
  const [subFinal, setSubFinal] = useState(0);
  const [grandTotal, setGrandTotal] = useState(0);
  const [isVatChecked, setIsVatChecked] = useState(true);
  const [vatAmount, setVatAmount] = useState(0);

  // การแสดงสถานะเอกสาร
  const [statusTransportName, setStatusTransportName] = useState("");
  const [statusTransportColour, setStatusTransportColour] = useState("");
  const [statusPaidName, setStatusPaidName] = useState("");
  const [statusPaidColour, setStatusPaidColour] = useState("");
  const [statusPaidTypeName, setStatusPaidTypeName] = useState("");
  const [statusPaidTypeColour, setStatusPaidTypeColour] = useState("");

  // สำหรับเก็บประเภทการชำระเงิน
  const [paymentType, setPaymentType] = useState({});
  const [paymentAmount, setPaymentAmount] = useState({});

  // เก็บตัวแปรสำหรับเช็ค
  const [chequeNo, setChequeNo] = useState("");
  const [chequeName, setChequeName] = useState("");
  const [chequeBranch, setChequeBranch] = useState("");

  const [base64Image, setBase64Image] = useState("");

  // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
  const [isBl, setIsBl] = useState(false);

  // สำหรับตัวแปรดักป้องกันการกดซ้ำ
  const [showConfirmModal, setShowConfirmModal] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  // สำหรับ Freeze หน้าจอตอนทำรายการ
  const [isLoading, setIsLoading] = useState(false);
  const [displayDocNo, setDisplayDocNo] = useState(maxDocNo);


  const [transportList, setTransportList] = useState([]);

  useEffect(() => {
    initialize();
  }, []);

  useEffect(() => {
    setDisplayDocNo(maxDocNo);
  }, [maxDocNo]);

  useEffect(() => {
    if (mode === "U" || !formMasterList.docDate || !isVatChecked) return undefined;

    let isActive = true;
    const refreshDisplayDocNo = async () => {
      try {
        const masterList = await getDataWithComp(
          "SO_H",
          `AND Doc_No LIKE 'INV%' ORDER BY Doc_No DESC`
        );
        const nextDocNo = getMaxInvNo(masterList, formMasterList.docDate);
        if (isActive) setDisplayDocNo(nextDocNo);
      } catch (error) {
        console.error("Unable to refresh invoice document number", error);
      }
    };

    refreshDisplayDocNo();
    return () => {
      isActive = false;
    };
  }, [mode, formMasterList.docDate, isVatChecked]);

  const initialize = async () => {
    try {
      // เคลียร์ค่าทุกครั้งที่เปิดหน้าจอมา (แก้ปัญหา List ข้อมูลชอบค้าง)
      setFormMasterList(soMasterModel());
      setFormDetailList([]);

      const docTypeList = await getDocType(2);
      if (docTypeList && docTypeList.length > 0) {
        setTbDocType(docTypeList);
      }

      const transTypeList = await getTransType();
      if (transTypeList && transTypeList.length > 0) {
        setTbTransType(transTypeList);
      }

      // const qtDataList = await Axios.post(
      //   `${process.env.REACT_APP_API_URL}/api/get-qt-by-so`,
      //   {
      //     comp_id: window.localStorage.getItem("company"),
      //   },
      //   {
      //     headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
      //   }
      // );
      const qtDataList = await getDataWithComp(
        "API_0601_QT_H",
        "ORDER BY Doc_No DESC"
      );

      if (qtDataList && qtDataList.length > 0) {
        // ดึงข้อมูล SO_H เพื่อเช็ค Ref_Doc และ Doc_Status
        const soDataList = await getDataWithComp("API_0701_SO_H", "");

        // กรอง qtDataList โดยให้ Doc_No ยังไม่เคยถูกใช้ใน SO_H หรือใช้แต่มีสถานะยกเลิก (Doc_Status = 13)
        const filteredQtDataList = qtDataList.filter((qt) => {
          const usedInSO = soDataList.some(
            (so) => so.Ref_Doc === qt.Doc_No && so.Doc_Status !== 13
          );
          return !usedInSO;
        });

        setQtDataList(filteredQtDataList);
      }

      const arDataList = await getDataWithComp(
        "Tb_Set_AR",
        "ORDER BY AR_Code ASC"
      );
      if (arDataList && arDataList.length > 0) {
        setArDataList(arDataList);
      }

      const itemDataList = await getDataWithComp(
        "View_Set_Item",
        `ORDER BY Item_Id ASC`
      );
      // console.debug("itemDataList", itemDataList);
      if (itemDataList && itemDataList.length > 0) {
        setItemDataList(itemDataList);
      }

      const whDataList = await getDataWithComp(
        "Tb_Set_Wh",
        `AND WH_Status = 'Y' ORDER BY Flag_Vansale, WH_Name ASC`
      );

      const salemanList = await getDataWithComp(
        "Tb_Set_Employee",
        `AND  Emp_Position = ${4} ORDER BY Emp_Id ASC`
      );

      const setwh = await getDataWithComp(
        "Tb_Set_WH",
        "and WH_Default_Sale = 'Y'"
      );
      if (setwh && setwh.length > 0) {
        setWhid(setwh?.at(0).WH_Id);
      }

      if (salemanList && salemanList.length > 0) {
        setSalemanList(salemanList);
      }

      if (whDataList && whDataList.length > 0) {
        setWhDataList(whDataList);
      }

      // Default จำนวนการชำระไว้ก่อนเป็น 0.00
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
        cheque: "0.00",
        credit: "0.00",
        unpaid: "0.00",
      });

      // สำหรับ View เข้ามาเพื่อแก้ไขข้อมูล
      if (mode === "U") {
        await getModelByNo(arDataList);
      }
    } catch (error) {
      getAlert("FAILED", error.message);
    }
  };



  const options = saleman
    .slice() // ป้องกันไม่ให้แก้ของเดิม
    .sort((a, b) => a.Emp_Id - b.Emp_Id) // เรียงจากน้อยไปมาก
    .map((ap) => ({
      value: ap.Emp_Id,
      label: `${ap.Emp_Prefix} ${ap.Emp_Name}`,
    }));



  const getModelByNo = async (arDataList) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      const findMaster = await getDataWithComp("SO_H", ``);
      const fromDatabase = findMaster.find((so) => so.Doc_No === maxDocNo);

      if (!fromDatabase) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลเอกสาร");
      }

      // ค้นหาข้อมูลผู้ขายด้วย AR_ID
      const fromViewAr = arDataList.find(
        (ap) => ap.AR_Id === fromDatabase.AR_ID
      );
      if (!fromViewAr) {
        setIsLoading(false);
        throw new Error("ไม่พบข้อมูลลูกค้า");
      }

      // ค้นหาข้อมูล VIEW
      const findViewMaster = await getDataWithComp("API_0701_SO_H", "");
      const fromView = findViewMaster.find((data) => data.Doc_No === maxDocNo);
      setStatusTransportName(fromView.DocStatusTransport_Name);
      setStatusTransportColour(fromView.DocStatusTransport_Colour);
      setStatusPaidName(fromView.DocStatusPaid_Name);
      setStatusPaidColour(fromView.DocStatusPaid_Colour);
      setStatusPaidTypeName(fromView.DocStatusPaid_Type_Name);
      setStatusPaidTypeColour(fromView.DocStatusPaidType_Colour);

      // สำหรับเช็กเงื่อนไขว่าสร้างวางบิลหรือยัง ?
      const findBlBySoId = await getData(
        "BL_D",
        `SO_Id = ${fromDatabase.Doc_Id}`
      );
      if (findBlBySoId && findBlBySoId.length > 0) {
        setIsBl(true);
      }

      // ฟังก์ชันเพื่อดึงข้อมูล itemOnHand และอัปเดตทีหลัง
      const updateItemOnHandLater = async (newRow, whId, itemId, itemQty) => {
        try {
          // ดึงข้อมูลทั้งหมดในครั้งเดียว
          const [itemOnHandData] = await Promise.all([
            getDataWithComp(
              "API_1101_WH_ITEM_ONHAND",
              `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
                itemId
              )}`
            ),
          ]);

          if (!itemOnHandData || itemOnHandData.length === 0) {
            newRow.itemOnHand = 0;
          } else {
            let newItemOnHand = parseCurrency(itemOnHandData[0].Item_Onhand);

            newItemOnHand += parseCurrency(itemQty) || 0;
            newRow.itemOnHand = newItemOnHand;
          }

          // อัปเดต UI
          setFormDetailList((prevDetails) =>
            prevDetails.map((detail) =>
              detail.itemId === newRow.itemId
                ? { ...detail, itemOnHand: newRow.itemOnHand }
                : detail
            )
          );
        } catch (error) {
          setIsLoading(false);
          getAlert("FAILED", error.message || error);
        }
      };

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        const itemDisType = String(itemSelected.Item_DisType);
        let itemTotal = itemQty * itemPriceUnit;

        itemTotal -=
          itemDisType === "2"
            ? (itemDiscount / 100) * itemTotal // ลดตามเปอร์เซ็นต์
            : itemDiscount; // ลดตามจำนวนเงิน

        const newRow = {
          ...soDetailModel(index + 1),
          dtId: itemSelected.DT_Id,
          docId: itemSelected.Doc_ID,
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty: formatCurrency(itemQty),
          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType,
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          dsSeq: itemSelected.DS_SEQ,
          whId: itemSelected.WH_Id,
          outStock: itemSelected.out_stock || itemSelected.Out_Stock || 0, // โหลดค่า out_stock จาก DB (ลอง lowercase ก่อน)

          itemOnHand: "-",
        };

        if (itemSelected.WH_Id != null) {
          updateItemOnHandLater(
            newRow,
            itemSelected.WH_Id,
            itemSelected.Item_Id,
            itemQty
          );
        }

        return newRow; // ส่ง newRow กลับทันที
      };

      // ค้นหาข้อมูลของ Detail ด้วย Doc_ID
      const fromDetail = await getByDocId(
        "SO_D",
        fromDatabase.Doc_Id,
        `ORDER BY Line ASC`
      );

      if (fromDetail.length > 0) {
        const newFormDetails = fromDetail.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );

        // ตรวจสอบว่ามี docInvNo หรือไม่ เพื่อตัดสินใจว่าจะดึง placeDelivery และเงื่อนไขการชำระจากไหน
        let placeDelivery = "";
        let placeDelivery2 = "";
        let placeDelivery3 = "";
        let creditData = {
          credit: Boolean(fromDatabase.Credit_Term),
          credit_Term: fromDatabase.Credit_Term || 0
        };

        // โหลดข้อมูล transport ทั้งหมดเพื่อให้สามารถเลือกได้
        const transportData = await getData(
          "Tb_Set_ARTransport",
          `AR_Id = ${fromDatabase.AR_ID}`
        );
        setTransportList(transportData || []);

        // ใช้ข้อมูลจาก SO_H เสมอสำหรับที่อยู่ส่งของ (เพื่อให้แสดงข้อมูลที่บันทึกไว้ รวมถึง Place_Delivery3)
        placeDelivery = fromDatabase.Place_Delivery || "";
        placeDelivery2 = fromDatabase.Place_Delivery2 || "";
        placeDelivery3 = fromDatabase.Place_Delivery3 || "";

        if (!fromDatabase.Doc_INV_No) {
          // ดึงเงื่อนไขการชำระจาก Tb_Set_AR (กรณีที่ยังไม่มีเลข Invoice - Logic เดิม)
          if (fromViewAr) {
            creditData = {
              credit: fromViewAr.AR_Credit === 1,
              credit_Term: fromViewAr.AR_Credit === 1 ? fromViewAr.AR_Credit_Term : 0
            };
          }
        } else {
          // ใช้เงื่อนไขการชำระจาก SO_H ตามเดิม
          creditData = {
            credit: Boolean(fromDatabase.Credit_Term),
            credit_Term: fromDatabase.Credit_Term || 0
          };
        }
        const saleEmpId = parseInt(fromDatabase.Sale_name, 10);
        let findSaleName = null;
        if (!isNaN(saleEmpId)) {
          const empRows = await getDataWithComp(
            "Tb_Set_Employee",
            `AND Emp_Id = ${saleEmpId}`
          );
          findSaleName = empRows && empRows.length > 0 ? empRows[0] : null;

          if (findSaleName) {
            setSalemanList((prev) => {
              const exists = prev.some((e) => e.Emp_Id === findSaleName.Emp_Id);
              return exists ? prev : [...prev, findSaleName];
            });
          }
        }
        setFormDetailList(newFormDetails);
        setFormMasterList({
          docId: fromDatabase.Doc_Id,
          compId: fromDatabase.Comp_Id,
          docNo: fromDatabase.Doc_No,
          docDate: formatThaiDateUi(fromDatabase.Doc_Date || null),
          docStatus: fromDatabase.Doc_Status,
          docStatusTransport: fromDatabase.Doc_Status_Transport,
          docStatusReceive: fromDatabase.Doc_Status_Receive,
          docStatusPaid: fromDatabase.Doc_Status_Paid,
          docStatusPaidType: fromDatabase.Doc_Status_Paid_Type,
          docCode: fromDatabase.Doc_Code,
          docType: fromDatabase.Doc_Type,
          docFor: fromDatabase.Doc_For,
          docIsPickingList: fromDatabase.Doc_Is_PickingList,
          docIsInv: fromDatabase.Doc_Is_INV,
          docInvNo: fromDatabase.Doc_INV_No,
          docIsInvFrom: fromDatabase.Doc_Is_INV_From,
          refDocID: fromDatabase.Ref_DocID,
          refDoc: fromDatabase.Ref_Doc,
          refDocDate: formatThaiDateUi(fromDatabase.Ref_DocDate || null),
          refProjectID: fromDatabase.Ref_ProjectID,
          refProjectNo: fromDatabase.Ref_ProjectNo,
          transportType: fromDatabase.Transport_Type,
          docRemark1: fromDatabase.Doc_Remark1,
          docRemark2: fromDatabase.Doc_Remark2,
          arID: fromDatabase.AR_ID,
          arCode: fromDatabase.AR_Code,
          doc_due_date: fromDatabase.Doc_DueDate || null,
          actionHold: fromDatabase.Action_Hold,
          discountValue: fromDatabase.Discount_Value,
          discountValueType: fromDatabase.Discount_Value_Type,
          discountCash: fromDatabase.Discount_Cash,
          discountCashType: fromDatabase.Discount_Cash_Type,
          discountTransport: fromDatabase.Discount_Transport,
          discountTransportType: fromDatabase.Discount_Transport_Type,
          isVat: fromDatabase.IsVat,
          docSEQ: fromDatabase.Doc_SEQ,
          // ตรงนี้
          creditTerm: fromDatabase.CreditTerm,
          creditTerm1Day: fromDatabase.CreditTerm1Day,
          creditTerm1Remark: fromDatabase.CreditTerm1Remark,
          creditTerm2Remark: fromDatabase.CreditTerm2Remark,
          accCode: fromDatabase.ACC_Code,
          empName: fromDatabase.EmpName,
          createdDate: setCreateDateTime(fromDatabase.Created_Date || null),
          createdByName: fromDatabase.Created_By_Name,
          createdById: fromDatabase.Created_By_Id,
          updateDate: setCreateDateTime(fromDatabase.Update_Date || null),
          updateByName: fromDatabase.Update_By_Name,
          updateById: fromDatabase.Update_By_Id,
          approvedDate: setCreateDateTime(fromDatabase.Approved_Date || null),
          approvedByName: fromDatabase.Approved_By_Name,
          approvedById: fromDatabase.Approved_By_Id,
          cancelDate: setCreateDateTime(fromDatabase.Cancel_Date || null),
          cancelByName: fromDatabase.Cancel_By_Name,
          cancelById: fromDatabase.Cancel_By_Id,
          approvedMemo: fromDatabase.Approved_Memo,
          printedStatus: fromDatabase.Printed_Status,
          printedDate: setCreateDateTime(fromDatabase.Printed_Date || null),
          printedBy: fromDatabase.Printed_By,
          docPaidPic: fromDatabase.Doc_Paid_Pic,
          payTotal: fromDatabase.Pay_Total,
          refBillNo: fromDatabase.Ref_Bill_No,
          docSoReceiveDate: formatThaiDateUi(
            fromDatabase.Doc_SO_Receive_Date || null
          ),

          arName: fromViewAr.AR_Name,
          // กรณีแก้ไข: ดึงที่อยู่จาก SO_H เป็นหลัก (ตามความต้องการ)
          arAdd1: fromDatabase.AR_Add1 || fromViewAr.AR_Add1,
          arAdd2: fromDatabase.AR_Add2 || fromViewAr.AR_Add2,
          arAdd3: fromDatabase.AR_Add3 || fromViewAr.AR_Add3,
          arProvince: fromViewAr.AR_Province,
          arZipcode: fromViewAr.AR_Zipcode,
          arTaxNo: fromViewAr.AR_TaxNo,
          dateSend: fromDatabase.Date_Send || null,

          // กรณีแก้ไข: ดึงสถานที่ส่งของจาก SO_H เป็นหลัก (ตามความต้องการ)
          placeDelivery: placeDelivery,
          placeDelivery2: placeDelivery2,
          placeDelivery3: placeDelivery3,

          saleName: findSaleName?.Emp_Name || null,
          credit: creditData.credit,
          credit_Term: creditData.credit_Term,
          refBilldate: formatThaiDateUi(fromDatabase.Ref_Bill_Date || null),
        });

        setIsVatChecked(fromDatabase.IsVat === 1);

        const discountValueType = parseCurrency(
          fromDatabase.Discount_Value_Type
        );
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }

        setSelectedDiscountValueType(String(fromDatabase.Discount_Value_Type));

        // กำหนดประเภทการจ่ายต่อ กรณีที่ค้างจ่าย
        if (fromDatabase.Doc_Status_Paid === 2) {
          switch (fromDatabase.Doc_Status_Paid_Type) {
            // ถ้าเป็น 1 คือ เงินสด
            case 1:
              setPaymentType({
                cash: true,
                transfer: false,
                cheque: false,
                credit: false,
                unpaid: false,
              });
              setPaymentAmount({
                cash: formatCurrency(fromDatabase.Pay_Total),
                transfer: "0.00",
                cheque: "0.00",
                credit: "0.00",
                unpaid: "0.00",
              });
              break;

            // ถ้าเป็น 2 คือ เงินโอน
            case 2:
              setPaymentType({
                cash: false,
                transfer: true,
                cheque: false,
                credit: false,
                unpaid: false,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: formatCurrency(fromDatabase.Pay_Total),
                cheque: "0.00",
                credit: "0.00",
                unpaid: "0.00",
              });
              break;

            // ถ้าเป็น 3 คือ เช็ค
            case 3:
              setPaymentType({
                cash: false,
                transfer: false,
                cheque: true,
                credit: false,
                unpaid: false,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: "0.00",
                cheque: formatCurrency(fromDatabase.Pay_Total),
                credit: "0.00",
                unpaid: "0.00",
              });

              const payHistoryForCheque = await getData(
                "Pay_History",
                `DocCode_Id = 7 AND Pay_Type = 3 AND Doc_Id = ${fromDatabase.Doc_Id}`
              );
              if (payHistoryForCheque && payHistoryForCheque.length > 0) {
                const payData = payHistoryForCheque[0];
                setChequeNo(payData.Pay_Cheque_No);
                setChequeName(payData.Pay_Cheque_Branch);
                setChequeBranch(
                  moment(payData.Pay_Cheque_date)
                    .add(543, "years")
                    .format("DD/MM/YYYY")
                );
              }

              break;

            // ถ้าเป็น 4 คือ เครดิต
            case 4:
              setPaymentType({
                cash: false,
                transfer: false,
                cheque: false,
                credit: true,
                unpaid: false,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: "0.00",
                cheque: "0.00",
                credit: formatCurrency(fromView.NetTotal),
                unpaid: "0.00",
              });
              break;

            // ถ้าเป็น 5 คือ ค้างจ่าย
            case 5:
              setPaymentType({
                cash: false,
                transfer: false,
                cheque: false,
                credit: false,
                unpaid: true,
              });
              setPaymentAmount({
                cash: "0.00",
                transfer: "0.00",
                cheque: "0.00",
                credit: "0.00",
                unpaid: formatCurrency(fromView.NetTotal),
              });
              break;

            // ถ้าเป็น 6 แปลว่าจ่ายหลายช่องทาง ต้องไปค้นหาที่ Table : Pay_History เพิ่ม
            case 6:
              const paymentHistoryResponse = await getData(
                "Pay_History",
                `DocCode_Id = 7 AND Doc_Id = ${fromDatabase.Doc_Id}`
              );
              if (paymentHistoryResponse && paymentHistoryResponse.length > 0) {
                // Loop ผ่านข้อมูลการจ่ายหลายช่องทาง
                for (const payment of paymentHistoryResponse) {
                  switch (payment.Pay_Type) {
                    // ถ้า payment.Pay_Type === 1 คือ เงินสด
                    case 1:
                      setPaymentType((prev) => ({
                        ...prev,
                        cash: true,
                      }));
                      setPaymentAmount((prev) => ({
                        ...prev,
                        cash: formatCurrency(payment.Pay_Amount),
                      }));
                      break;

                    // ถ้า payment.Pay_Type === 2 คือ เงินโอน
                    case 2:
                      setPaymentType((prev) => ({
                        ...prev,
                        transfer: true,
                      }));
                      setPaymentAmount((prev) => ({
                        ...prev,
                        transfer: formatCurrency(payment.Pay_Amount),
                      }));
                      break;

                    // ถ้า payment.Pay_Type === 3 คือ เช็ค
                    case 3:
                      setPaymentType((prev) => ({
                        ...prev,
                        cheque: true,
                      }));
                      setPaymentAmount((prev) => ({
                        ...prev,
                        cheque: formatCurrency(payment.Pay_Amount),
                      }));

                      // ถ้าเป็นเช็ค ต้องเซ็ทเลขที่เช็ค ชื่อ และ วันที่แบบนี้ด้วย
                      setChequeNo(payment.Pay_Cheque_No);
                      setChequeName(payment.Pay_Cheque_Branch);
                      setChequeBranch(
                        moment(payment.Pay_Cheque_date)
                          .add(543, "years")
                          .format("DD/MM/YYYY")
                      );

                      break;

                    // กรณีที่ไม่ตรงกับ 1, 2, หรือ 3
                    default:
                      console.warn(
                        `พบประเภทการจ่ายที่ไม่รู้จัก: ${payment.Pay_Type}`
                      );
                      break;
                  }
                }
              }
              break;

            // กรณีอื่นๆ ถ้ามี
            default:
              console.log("ประเภทการจ่ายไม่ถูกต้อง");
              break;
          }
        }
      } else {
        setIsLoading(false);
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${fromDatabase.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleCheckboxChange = (event) => {
    const { name } = event.target;
    setSelectedDiscountValueType(
      selectedDiscountValueType === name ? null : name
    );
  };

  const calculateBomStockRecursive = async (
    itemId,
    baseQty = 1,
    whId = 0,
    parentId = null,
    level = 0
  ) => {
    const compId = localStorage.getItem("company");
    const where = `pro_id = ${itemId} AND Comp_Id = ${compId}`;
    const rawBomList = await getData("Tb_Set_ItemBOM", where);

    const allResults = [];

    const matchedItem =
      itemDataList.find((itm) => itm.Item_Id === itemId) ||
      (await getData("Tb_Set_Item", `Item_Id = ${itemId}`))?.[0] ||
      {};

    // ✅ ถ้าไม่มีลูก → ถือเป็นวัตถุดิบปลายทาง
    if (!rawBomList || rawBomList.length === 0) {
      allResults.push({
        Item_Id: itemId,
        Item_Code: matchedItem.Item_Code || "-",
        Item_Name: matchedItem.Item_Name || "-",
        Qty: baseQty,
        whId,
        parentId,
        level,
      });
      return allResults;
    }

    // ✅ ถ้าเป็น BOM ที่มีลูก → ใส่ตัวเองก่อน (สำหรับ tracking เท่านั้น)
    allResults.push({
      Item_Id: itemId,
      Item_Code: matchedItem.Item_Code || "-",
      Item_Name: matchedItem.Item_Name || "-",
      Qty: baseQty,
      whId,
      parentId,
      level,
    });

    for (const bom of rawBomList) {
      const childItemId = bom.item_id;
      const qtyInBom = parseFloat(bom.quantity || "0");
      const nextQty = baseQty * qtyInBom;

      const childResults = await calculateBomStockRecursive(
        childItemId,
        nextQty,
        whId,
        itemId,
        level + 1
      );

      allResults.push(...childResults);
    }

    return allResults;
  };

  // const handleSubmit = async () => {
  //   console.debug("handleSubmit", formMasterList, formDetailList);
  //   setIsLoading(true);

  //   const bomAll = {};

  //   for (const item of formDetailList) {
  //     if (!item.itemCode) continue;

  //     const itemQty = parseCurrency(item.itemQty);
  //     const itemwhId = parseCurrency(
  //       Array.isArray(item.whId) ? item.whId[0] : item.whId
  //     );

  //     if (item.isProjectItem) {
  //       const bomList = await calculateBomStockRecursive(
  //         item.itemId,
  //         itemQty,
  //         itemwhId
  //       );
  //       console.debug("bomList", bomList);
  //       for (const b of bomList) {
  //         const key = `${b.Item_Id}|${itemwhId}`;
  //         if (!bomAll[key]) {
  //           bomAll[key] = {
  //             Item_Id: b.Item_Id,
  //             Item_Code: b.Item_Code,
  //             Item_Name: b.Item_Name,
  //             Qty: 0,
  //             whId: itemwhId,
  //           };
  //         }
  //         bomAll[key].Qty += b.Qty;
  //       }
  //     }
  //   }

  //   console.debug("bomAll", bomAll);

  //   // ✅ ตัดสต็อก
  //   // for (const entry of Object.values(bomAll)) {
  //   //   await manageWhItemData(
  //   //     entry.Item_Id,
  //   //     entry.Item_Code,
  //   //     entry.Item_Name,
  //   //     entry.whId,
  //   //     "OUT",
  //   //     entry.Qty,
  //   //     docId,
  //   //     formMasterList.docNo,
  //   //     formMasterList.refDoc === null
  //   //       ? formMasterList.docNo
  //   //       : formMasterList.refDoc,
  //   //     `ตัดสต็อกจาก SO`
  //   //   );
  //   // }

  //   setIsLoading(false);
  // };

  const handleSubmit = async (
    docStatusPaid,
    docStatusPaidType,
    totalPaidAmount,
    isCutStock = null, // เพิ่ม parameter สำหรับบังคับค่าตัดสต็อก
    outStock = null // เพิ่ม parameter สำหรับบันทึก out_stock (1=ตัดสต็อก, 0=ไม่ตัดสต็อก)
  ) => {
    // console.log("handleSubmit", formMasterList, formDetailList);
    // console.debug("docStatusPaid
    if (isSubmitting) return getAlert("FAILED", "กรุณารอสักครู่");
    setIsSubmitting(true);

    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);
      if (!formMasterList.docDate) {
        getAlert("FAILED", "กรุณาระบุวันที่เอกสาร");
        return;
      }

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsSubmitting(false);
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      let index = 0;
      for (const item of formDetailList) {
        if (item.itemCode && item.itemCode !== "-") {
          // ทำการตรวจสอบจำนวนสินค้าที่สามารถขายได้อีกรอบ
          await handleChangeDetail(index, "whId", item.whId);
          // console.log("item", item);
          if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
            setIsSubmitting(false);
            setIsLoading(false);
            getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
            return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
          }
          if (
            formMasterList.arItemFree === "N" &&
            (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
          ) {
            setIsSubmitting(false);
            setIsLoading(false);
            getAlert(
              "FAILED",
              `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`
            );
            return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
          }
          if (!item.whId) {
            setIsSubmitting(false);
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
            );
            return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
          }
          // if (
          //   !item.isProjectItem &&
          //   parseCurrency(item.itemQty) > parseCurrency(item.itemOnHand)
          // ) {
          //   console.log(1)
          //   getAlert(
          //     "FAILED",
          //     `จำนวนสินค้า ${item.itemName} ไม่พอ กรุณาทำรายการใหม่`
          //   );
          //   return;
          // }

          // if (
          //   !item.isProjectItem &&
          //   parseCurrency(item.itemQty) > parseCurrency(item.itemOnHand)
          // ) {
          //   console.log(2)
          //   setIsSubmitting(false);
          //   setIsLoading(false);
          //   getAlert(
          //     "FAILED",
          //     `จำนวนสินค้า ${item.itemName} ไม่พอ กรุณาทำรายการใหม่`
          //   );
          //   return;
          // }
        }

        index++;
      }

      // ทดสอบหน่วงเวลาก่อนบันทึก (ทดสอบป้องกันการซ้ำของ Doc_No)
      await randomDelay();

      let newMaxDoc = "UNKNOWN"; // กำหนดค่าเริ่มต้น
      let newMaxRec = null; // กำหนดค่าเริ่มต้น
      let newDateRec = null; // กำหนดค่าเริ่มต้น


      if (paymentType.credit) {
        console.log("กรณีลูกค้าขายเชื่อ");
        // กรณีลูกค้าขายเชื่อ
        if (isVatChecked) {
          // VAT
          const masterList = await getDataWithComp(
            "SO_H",
            `AND Doc_No LIKE 'INV%' ORDER BY Doc_No DESC`
          );
          newMaxDoc = getMaxInvNo(masterList, formMasterList.docDate);
        } else {
          // ไม่ VAT
          const masterList = await getDataWithComp(
            "SO_H",
            `AND Doc_No LIKE 'DSR%' ORDER BY Doc_No DESC`
          );
          newMaxDoc = getMaxDsrNo(masterList);
        }
      } else {
        // กรณีลูกค้าขายสด
        if (isVatChecked) {
          // VAT
          const masterList = await getDataWithComp(
            "SO_H",
            `AND Doc_No LIKE 'INV%' ORDER BY Doc_No DESC`
          );
          newMaxDoc = getMaxInvNo(masterList, formMasterList.docDate);

          // ทำการสร้างใบเสร็จรับเงิน และ รันเลข REC ที่ Tb_Set_Rec_No ล่าสุด
          // const findMaxRecNo = await getData(
          //   "Tb_Set_Rec_No",
          //   `1 = 1 ORDER BY RecNo DESC`
          // );
          // newMaxRec = getMaxRecNoForTest(findMaxRecNo);
          // newDateRec = getCreateDateTime();
          // await createSetRecNo(newMaxRec);
        } else {
          // ไม่ VAT
          const masterList = await getDataWithComp(
            "SO_H",
            `AND Doc_No LIKE 'CS%' ORDER BY Doc_No DESC`
          );
          newMaxDoc = getMaxCsNo(masterList);
        }
      }
      // เอาชื่อไป หาใน Tb_Set_Employee เพื่อหาค่า Emp_Id
      // console.log("formMasterList.saleName", formMasterList.saleName);
      const empData = await getDataWithComp(
        "Tb_Set_Employee",
        `AND Emp_Name = '${formMasterList.saleName}'`
      );

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: newMaxDoc,
        doc_date: formatDateForUpdate(formMasterList.docDate),
        doc_status: parseCurrency("2"),
        doc_status_transport: parseCurrency("3"),
        doc_status_receive: parseCurrency("3"),
        doc_status_paid: parseCurrency(docStatusPaid),
        doc_status_paid_type: parseCurrency(docStatusPaidType),
        doc_code: parseCurrency("7"),
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: 0,
        doc_is_inv: "N",
        doc_inv_no: newMaxRec,
        doc_is_inv_from: parseCurrency("0"),
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_doc_date: formatThaiDateUiToDate(formMasterList.refDocDate),
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: parseCurrency(formMasterList.arID, 10),
        ar_code: formMasterList.arCode,
        doc_due_date: formMasterList.doc_due_date ? formatDateForUpdate(formMasterList.doc_due_date) : null,
        action_hold: parseCurrency("0", 10),
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: parseCurrency("0.00"),
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: parseCurrency("0.00"),
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: "0000",
        emp_name: formMasterList.empName,
        created_date: formatThaiDateUiToDate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formMasterList.updateDate,
        update_by_name: formMasterList.updateByName,
        update_by_id: formMasterList.updateById,
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: "N",
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: parseCurrency(
          paymentType.credit || paymentType.unpaid ? "0" : totalPaidAmount
        ),
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: newDateRec
          ? formatThaiDateUiToDate(newDateRec)
          : null,

        dateSend: formMasterList.dateSend ? formatDateForUpdate(formMasterList.dateSend) : null,
        placeDeliver: formMasterList.placeDelivery,
        placeDeliver2: formMasterList.placeDelivery2,
        placeDeliver3: formMasterList.placeDelivery3,
        credit_Term: formMasterList.credit_Term,
        // เอา ID ของพนักงานขายจาก empData
        saleName: empData && empData.length > 0 ? empData[0].Emp_Id : null,
        refBilldate: formatDateForUpdate(formMasterList.refBilldate),
        is_cut_stc: (isCutStock !== null ? isCutStock : formMasterList.isCutSTC) === "Y" ? "Y" : "N",
        is_cut_stc_invno: (isCutStock !== null ? isCutStock : formMasterList.isCutSTC) === "Y" ? newMaxDoc : null,
        ar_add1: formMasterList.arAdd1,
        ar_add2: formMasterList.arAdd2,
        ar_add3: formMasterList.arAdd3,
      };

      // ส่งข้อมูลหลักไปยัง API

      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/create-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      if (base64Image) {
        const formData = {
          comp_id: window.localStorage.getItem("company"),
          doc_no: newMaxDoc,
          doc_paid_pic: base64Image,
        };

        await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`,
          formData,
          { headers: { key: process.env.REACT_APP_ANALYTICS_KEY } }
        );
      }

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const getDocIdResponse = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/get-by-doc-no`,
          {
            table: "SO_H",
            doc_no: formMasterData.doc_no,
            comp_id: window.localStorage.getItem("company"),
          },
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );

        // ส่งข้อมูลรายละเอียดหากพบ Doc_Id
        if (getDocIdResponse && getDocIdResponse.data.length > 0) {
          const docId = parseCurrency(getDocIdResponse.data[0].Doc_Id, 10);

          // Patch Address explicitly (in case API doesn't handle it)
          // บันทึกที่อยู่ลง SO_H (ตามความต้องการ: บันทึกข้อมูลที่อยู่ / สถานที่ส่งของ ไปที่ SO_H)
          const safeAddr1 = (formMasterList.arAdd1 || "").replace(/'/g, "''");
          const safeAddr2 = (formMasterList.arAdd2 || "").replace(/'/g, "''");
          const safeAddr3 = (formMasterList.arAdd3 || "").replace(/'/g, "''");
          await updateData(
            "SO_H",
            `AR_Add1 = '${safeAddr1}', AR_Add2 = '${safeAddr2}', AR_Add3 = '${safeAddr3}'`,
            `Doc_Id = ${docId}`
          );

          // บันทึกที่อยู่ลง Set_AR_INVAddress (ตามความต้องการ: บันทึกข้อมูลที่อยู่ / สถานที่ส่งของ ไปที่ Set_AR_INVAddress)
          if (formMasterList.arID) {
            const compId = window.localStorage.getItem("company");
            const safeDelivery1 = (formMasterList.placeDelivery || "").replace(/'/g, "''");
            const safeDelivery2 = (formMasterList.placeDelivery2 || "").replace(/'/g, "''");
            const safeDelivery3 = (formMasterList.placeDelivery3 || "").replace(/'/g, "''");

            // ตรวจสอบว่ามีข้อมูลอยู่แล้วหรือไม่
            const existing = await getDataWithComp(
              "Set_AR_INVAddress",
              `AND AR_ID = ${formMasterList.arID}`
            );

            if (existing && existing.length > 0) {
              // Update existing record
              await updateData(
                "Set_AR_INVAddress",
                `AR_Address1 = '${safeAddr1}', AR_Address2 = '${safeAddr2}', AR_Address3 = '${safeAddr3}', AR_Delivery1 = '${safeDelivery1}', AR_Delivery2 = '${safeDelivery2}', AR_Delivery3 = '${safeDelivery3}'`,
                `AR_ID = ${formMasterList.arID} AND Comp_Id = '${compId}'`
              );
            } else {
              // Insert new record
              const allAddresses = await getData("Set_AR_INVAddress", "1=1 ORDER BY Inv_Add_Id DESC");
              let newId = 1;
              if (allAddresses && allAddresses.length > 0) {
                newId = allAddresses[0].Inv_Add_Id + 1;
              }

              await insertData(
                "Set_AR_INVAddress",
                "Inv_Add_Id, AR_ID, Comp_Id, AR_Address1, AR_Address2, AR_Address3, AR_Delivery1, AR_Delivery2, AR_Delivery3",
                [newId, formMasterList.arID, compId, safeAddr1, safeAddr2, safeAddr3, safeDelivery1, safeDelivery2, safeDelivery3]
              );
            }
          }

          const detailPromises = formDetailList.map(async (item, index) => {
            const formDetailData = {
              doc_id: parseCurrency(docId, 10),
              line: index + 1,
              item_id: item.itemId || null,
              item_code:
                item.itemCode === "BOM" || item.isSpecRow ? "" : item.itemCode,
              item_name: item.itemName,
              item_qty: item.isSpecRow ? 1 : parseCurrency(item.itemQty), // Spec = 1 เสมอ
              item_unit: item.isSpecRow ? "" : item.itemUnit,
              item_price_unit: item.isSpecRow
                ? 0
                : parseCurrency(item.itemPriceUnit),
              item_discount: item.isSpecRow
                ? 0
                : parseCurrency(item.itemDiscount),
              item_distype: item.isSpecRow
                ? parseCurrency("1", 10)
                : item.itemDisType === "1"
                  ? parseCurrency("1", 10)
                  : parseCurrency("2", 10),
              item_total: item.isSpecRow ? 0 : parseCurrency(item.itemTotal),
              item_status: parseCurrency("1", 10),
              ds_seq: item.dsSeq,
              wh_id: item.whId,
              out_stock: outStock !== null ? outStock : (item.outStock || 0), // บันทึก out_stock
            };

            return Axios.post(
              `${process.env.REACT_APP_API_URL}/api/create-so-d`,
              formDetailData,
              {
                headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
              }
            );
          });

          await Promise.all(detailPromises);

          // ใช้ค่า isCutStock ที่ส่งเข้ามา ถ้าไม่มีให้ใช้จาก formMasterList
          const shouldCutStock = (isCutStock !== null ? isCutStock : formMasterList.isCutSTC) === "Y";

          if (shouldCutStock) {
            const bomAll = {};

            for (const item of formDetailList) {
              // ข้าม Spec row, BOM child items, และ BOM placeholder (ไม่ต้องตัดสต็อก)
              if (!item.itemCode || item.isSpecRow || item.isBOMChild || item.itemCode === "BOM") {
                continue;
              }

              const itemQty = parseCurrency(item.itemQty);
              const itemwhId = parseCurrency(
                Array.isArray(item.whId) ? item.whId[0] : item.whId
              );

              if (item.isProjectItem) {
                const bomList = await calculateBomStockRecursive(
                  item.itemId,
                  itemQty,
                  itemwhId
                );
                for (const b of bomList) {
                  const key = `${b.Item_Id}|${itemwhId}`;
                  if (!bomAll[key]) {
                    bomAll[key] = {
                      Item_Id: b.Item_Id,
                      Item_Code: b.Item_Code,
                      Item_Name: b.Item_Name,
                      Qty: 0,
                      whId: itemwhId,
                    };
                  }
                  bomAll[key].Qty += b.Qty;
                }
              }
            }

            for (const entry of Object.values(bomAll)) {
              await manageWhItemData(
                entry.Item_Id,
                entry.Item_Code,
                entry.Item_Name,
                entry.whId,
                "OUT",
                entry.Qty,
                docId,
                newMaxDoc,
                formMasterList.refDoc === null
                  ? newMaxDoc
                  : formMasterList.refDoc,
                `ตัดสต็อกจากใบกำกับภาษี`
              );
            }


            for (const item of formDetailList) {
              // ข้าม Spec row, Project item (BOM), BOM child items, และ BOM placeholder (ไม่ต้องตัดสต็อก)
              if (!item.itemCode || item.isProjectItem || item.isSpecRow || item.isBOMChild || item.itemCode === "BOM") {
                continue;
              }

              const itemQty = parseCurrency(item.itemQty);
              const itemwhId = parseCurrency(
                Array.isArray(item.whId) ? item.whId[0] : item.whId
              );

              await manageWhItemData(
                item.itemId,
                item.itemCode,
                item.itemName,
                itemwhId,
                "OUT",
                itemQty,
                docId,
                newMaxDoc,
                formMasterList.refDoc === null
                  ? newMaxDoc
                  : formMasterList.refDoc,
                `ตัดสต๊อกจากใบกำกับภาษี `
              );
            }
          }

          const paymentTypeMap = {
            cash: 1,
            transfer: 2,
            cheque: 3,
            credit: 4,
            unpaid: 5,
          };

          for (const method of Object.keys(paymentType)) {
            if (
              paymentType[method] &&
              parseCurrency(paymentAmount[method]) > 0 &&
              (paymentTypeMap[method] === 1 ||
                paymentTypeMap[method] === 2 ||
                paymentTypeMap[method] === 3)
            ) {
              const formPaymentHistoryData = {
                doc_code_id: 7,
                doc_id: getDocIdResponse.data[0].Doc_Id,
                pay_type: paymentTypeMap[method],
                pay_amount:
                  docStatusPaidType === 6
                    ? parseCurrency(paymentAmount[method])
                    : parseCurrency(totalPaidAmount),
                pay_remark: null,
                pay_datetime: getCreateDateTime2(),
                pay_by: localStorage.getItem("name"),
                pay_to_acc_no: null,
                pay_to_branch: null,
                pay_to_acc_name: null,
                pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
                pay_cheque_name:
                  paymentTypeMap[method] === 3 ? chequeName : null,
                pay_cheque_branch:
                  paymentTypeMap[method] === 3 ? chequeBranch : null,
                pay_cheque_type: null,
              };

              // ส่งข้อมูลไปยัง API
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
                formPaymentHistoryData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            }
          }

          // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
          const getOldData = await getDataWithComp(
            "API_0701_SO_H",
            `AND Doc_ID = ${docId}`
          );
          if (getOldData && getOldData.length > 0) {
            const data = getOldData[0];
            // ปรับยอดเงินออก (เริ่มต้น)
            await manageWhArPaymentData(
              data.AR_ID, // AR_ID ของลูกค้านั้นๆ
              data.AR_Code, // AR_Code ของสิ่งนั้นๆ
              data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
              0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
              "AO", // ประเภท เช่น AI/AO
              data.NetTotal, // ค่าจำนวนเงิน
              data.Doc_ID, // ไอดีเอกสาร
              data.Doc_No, // เลขเอกสาร
              data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
              null // หมายเหตุ
            );

            if (
              paymentType.cash ||
              paymentType.transfer ||
              paymentType.cheque
            ) {
              if (data.Doc_Status_Paid_Type === 6) {
                const getPayHistory = await getData(
                  "Pay_History",
                  `DocCode_Id = 7 AND Doc_Id = ${formMasterList.docId}`
                );
                if (getPayHistory && getPayHistory.length > 0) {
                  for (const pay of getPayHistory) {
                    await manageWhArPaymentData(
                      data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                      data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                      data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                      0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                      "AI", // ประเภท เช่น AI/AO
                      data.Pay_Amount, // ค่าจำนวนเงิน
                      data.Doc_ID, // ไอดีเอกสาร
                      data.Doc_No, // เลขเอกสาร
                      data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                      await setRemarkByPaymentType(parseCurrency(pay.Pay_Type)) // หมายเหตุ
                    );
                  }
                }
              } else {
                // ปรับยอดเงินออก
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  data.Pay_Total, // ค่าจำนวนเงิน
                  data.Doc_ID, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(
                    parseCurrency(data.Doc_Status_Paid_Type)
                  ) // หมายเหตุ
                );
              }
            }
          }
        }
      }
      callInitialize();
      getAlert("OK", "บันทึกรายการใบกำกับภาษีสำเร็จ");
    } catch (error) {
      setIsSubmitting(false);
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    } finally {
      setIsSubmitting(false);
      setIsLoading(false);
    }
  };

  const [showPayTypeModal, setShowPayTypeModal] = useState(false);
  const handlePayTypeShow = () => setShowPayTypeModal(true);
  const handlePayTypeClose = async () => {
    setShowPayTypeModal(false);
    if (paymentType.credit) {
      setPaymentAmount({
        cash: "0.00",
        transfer: "0.00",
        cheque: "0.00",
        credit: paymentType.credit ? formatCurrency(grandTotal) : "0.00",
        unpaid: "0.00",
      });
    } else {
      setPaymentType({});
      setPaymentAmount({});
    }

    if (mode === "U") {
      setIsLoading(true);
      await initialize();
    }
  };

  const handleUploadSlip = (event) => {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => {
        setBase64Image(reader.result);
      };
      reader.readAsDataURL(file);
    }
  };

  // ฟังก์ชันสำหรับแปลงวันที่ให้เหมาะสมกับการอัพเดท
  const formatDateForUpdate = (dateValue) => {
    console.log("formatDateForUpdate input:", dateValue);
    if (!dateValue) return null;

    // ถ้าเป็น Date object
    if (dateValue instanceof Date) {
      const result = formatThaiDateUiToDate(formatThaiDateUi(dateValue));
      console.log("formatDateForUpdate Date object result:", result);
      return result;
    }

    // ถ้าเป็นรูปแบบ ISO format (YYYY-MM-DDTHH:mm:ss.SSSZ)
    if (typeof dateValue === 'string' &&
      dateValue.includes('T') &&
      dateValue.includes('Z') &&
      dateValue.length > 15) {
      // แปลง ISO format เป็น YYYY-MM-DD แล้วเพิ่มเวลา
      const dateOnly = dateValue.split('T')[0];
      const result = `${dateOnly} 00:00:00.000`;
      console.log("formatDateForUpdate ISO format result:", result);
      return result;
    }

    // ถ้าเป็นรูปแบบ YYYY-MM-DD
    if (typeof dateValue === 'string' &&
      dateValue.includes('-') &&
      dateValue.length === 10 &&
      dateValue.split('-')[0].length === 4) {
      // แปลง YYYY-MM-DD เป็น YYYY-MM-DD 00:00:00.000 (เพิ่มเวลา)
      const result = `${dateValue} 00:00:00.000`;
      return result;
    }

    // ถ้าเป็นรูปแบบ DD-MM-YYYY (จาก DatePicker ในโหมด U)
    if (typeof dateValue === 'string' &&
      dateValue.includes('-') &&
      dateValue.length === 10 &&
      dateValue.split('-')[2].length === 4) {
      const result = formatStringDateToDate(dateValue);
      console.log("formatDateForUpdate DD-MM-YYYY result:", result);
      return result;
    }

    // ถ้าเป็นรูปแบบอื่นๆ
    const result = formatThaiDateUiToDate(dateValue);
    console.log("formatDateForUpdate other format result:", result);
    return result;
  };

  const handleUpdate = async (shouldCutStock = true) => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (item.itemCode && item.itemCode !== "-") {
          if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
            setIsLoading(false);
            getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
            return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
          }
          if (
            formMasterList.arItemFree === "N" &&
            (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
          ) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`
            );
            return;
          }
          if (!item.whId) {
            setIsLoading(false);
            getAlert(
              "FAILED",
              `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
            );
            return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
          }
        }
      }
      const empData = await getDataWithComp(
        "Tb_Set_Employee",
        `AND Emp_Name = '${formMasterList.saleName}'`
      );
      // ข้อมูลหลักที่จะส่งไปยัง API
      console.log("formMasterList", formMasterList.doc_due_date);
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: formMasterList.docNo,
        doc_date: formatDateForUpdate(formMasterList.docDate),
        doc_status: formMasterList.docStatus,
        doc_status_transport: formMasterList.docStatusTransport,
        doc_status_receive: formMasterList.docStatusReceive,
        doc_status_paid: parseCurrency(formMasterList.docStatusPaid, 10),
        doc_status_paid_type: parseCurrency(
          formMasterList.docStatusPaidType,
          10
        ),
        doc_code: formMasterList.docCode,
        doc_type: formMasterList.docType,
        doc_for: formMasterList.docFor,
        doc_is_picking_list: formMasterList.docIsPickingList,
        doc_is_inv: formMasterList.docIsInv,
        ref_doc_id: formMasterList.refDocID,
        ref_doc: formMasterList.refDoc,
        ref_project_id: formMasterList.refProjectID,
        ref_project_no: formMasterList.refProjectNo,
        transport_type: formMasterList.transportType,
        doc_remark1: formMasterList.docRemark1,
        doc_remark2: formMasterList.docRemark2,
        ar_id: formMasterList.arID,
        ar_code: formMasterList.arCode,
        doc_due_date: formMasterList.doc_due_date ? formatDateForUpdate(formMasterList.doc_due_date) : null,
        dateSend: formMasterList.dateSend ? formatDateForUpdate(formMasterList.dateSend) : null,
        action_hold: formMasterList.actionHold,
        discount_value: parseCurrency(formMasterList.discountValue || 0.0),
        discount_value_type: parseCurrency(selectedDiscountValueType, 10),
        discount_cash: formMasterList.discountCash,
        discount_cash_type: formMasterList.discountCashType,
        discount_transport: formMasterList.discountTransport,
        discount_transport_type: formMasterList.discountTransportType,
        is_vat: isVatChecked ? parseCurrency("1", 10) : parseCurrency("2", 10),
        doc_seq: formatDateTime(new Date()),
        credit_term: parseCurrency(formMasterList.creditTerm, 10),
        credit_term_1_day: formMasterList.creditTerm1Day,
        credit_term_1_remark: formMasterList.creditTerm1Remark,
        credit_term_2_remark: formMasterList.creditTerm2Remark,
        acc_code: formMasterList.accCode,
        emp_name: formMasterList.empName,
        created_date: formatDateForUpdate(formMasterList.createdDate),
        created_by_name: formMasterList.createdByName,
        created_by_id: formMasterList.createdById,
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        cancel_date: formMasterList.cancelDate,
        cancel_by_name: formMasterList.cancelByName,
        cancel_by_id: formMasterList.cancelById,
        printed_status: formMasterList.printedStatus,
        printed_date: formMasterList.printedDate,
        printed_by: formMasterList.printedBy,
        pay_total: formMasterList.payTotal,
        ref_bill_no: formMasterList.refBillNo,
        doc_so_receive_date: formatDateForUpdate(formMasterList.docSoReceiveDate),
        placeDeliver: formMasterList.placeDelivery,
        placeDeliver2: formMasterList.placeDelivery2,
        placeDeliver3: formMasterList.placeDelivery3,
        credit_Term: formMasterList.credit_Term,
        saleName: empData && empData.length > 0 ? empData[0].Emp_Id : null,
        refBilldate: formatDateForUpdate(formMasterList.refBilldate),
        ar_add1: formMasterList.arAdd1,
        ar_add2: formMasterList.arAdd2,
        ar_add3: formMasterList.arAdd3,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        const docId = parseCurrency(formMasterList.docId, 10);

        // Patch Address explicitly (in case API doesn't handle it)
        // บันทึกที่อยู่ลง SO_H (ตามความต้องการ: บันทึกข้อมูลที่อยู่ / สถานที่ส่งของ ไปที่ SO_H)
        const safeAddr1 = (formMasterList.arAdd1 || "").replace(/'/g, "''");
        const safeAddr2 = (formMasterList.arAdd2 || "").replace(/'/g, "''");
        const safeAddr3 = (formMasterList.arAdd3 || "").replace(/'/g, "''");
        const safeDelivery1 = (formMasterList.placeDelivery || "").replace(/'/g, "''");
        const safeDelivery2 = (formMasterList.placeDelivery2 || "").replace(/'/g, "''");
        const safeDelivery3 = (formMasterList.placeDelivery3 || "").replace(/'/g, "''");

        await updateData(
          "SO_H",
          `AR_Add1 = '${safeAddr1}', AR_Add2 = '${safeAddr2}', AR_Add3 = '${safeAddr3}', Place_Delivery = '${safeDelivery1}', Place_Delivery2 = '${safeDelivery2}', Place_Delivery3 = '${safeDelivery3}'`,
          `Doc_Id = ${docId}`
        );

        // บันทึกที่อยู่ลง Set_AR_INVAddress (ตามความต้องการ: บันทึกข้อมูลที่อยู่ / สถานที่ส่งของ ไปที่ Set_AR_INVAddress)
        if (formMasterList.arID) {
          const compId = window.localStorage.getItem("company");

          // ตรวจสอบว่ามีข้อมูลอยู่แล้วหรือไม่
          const existing = await getDataWithComp(
            "Set_AR_INVAddress",
            `AND AR_ID = ${formMasterList.arID}`
          );

          if (existing && existing.length > 0) {
            // Update existing record
            await updateData(
              "Set_AR_INVAddress",
              `AR_Address1 = '${safeAddr1}', AR_Address2 = '${safeAddr2}', AR_Address3 = '${safeAddr3}', AR_Delivery1 = '${safeDelivery1}', AR_Delivery2 = '${safeDelivery2}', AR_Delivery3 = '${safeDelivery3}'`,
              `AR_ID = ${formMasterList.arID} AND Comp_Id = '${compId}'`
            );
          } else {
            // Insert new record
            const allAddresses = await getData("Set_AR_INVAddress", "1=1 ORDER BY Inv_Add_Id DESC");
            let newId = 1;
            if (allAddresses && allAddresses.length > 0) {
              newId = allAddresses[0].Inv_Add_Id + 1;
            }

            await insertData(
              "Set_AR_INVAddress",
              "Inv_Add_Id, AR_ID, Comp_Id, AR_Address1, AR_Address2, AR_Address3, AR_Delivery1, AR_Delivery2, AR_Delivery3",
              [newId, formMasterList.arID, compId, safeAddr1, safeAddr2, safeAddr3, safeDelivery1, safeDelivery2, safeDelivery3]
            );
          }
        }

        // ค้นหาใบขายใหม่อีกที (เพื่อเปรียบเทียบการเปลี่ยนแปลง)
        const getOldSoDetail = await getDataWithComp(
          "API_0702_SO_D",
          `AND Doc_ID = ${docId}`
        );

        // 📊 สร้าง Map ของข้อมูลเก่า เพื่อเปรียบเทียบ (พร้อมข้อมูล BOM)
        const oldItemMap = new Map();
        if (getOldSoDetail && getOldSoDetail.length > 0) {
          for (const soDetail of getOldSoDetail) {
            if (soDetail.Item_Id) {
              // ดึงข้อมูลสินค้าเพื่อเช็ค BOM status
              let isProjectItem = false;
              try {
                const itemData = await getData(
                  "Tb_Set_Item",
                  `Item_Id = ${soDetail.Item_Id}`
                );
                if (itemData && itemData.length > 0) {
                  isProjectItem = itemData[0].Is_BOM === "Y";
                }
              } catch (error) {
                console.warn("ไม่สามารถดึงข้อมูล BOM สำหรับ Item_Id:", soDetail.Item_Id);
              }

              const key = `${soDetail.Item_Id}|${soDetail.WH_Id}`;
              oldItemMap.set(key, {
                itemId: soDetail.Item_Id,
                itemCode: soDetail.Item_Code,
                itemName: soDetail.Item_Name,
                qty: parseCurrency(soDetail.Item_Qty),
                whId: soDetail.WH_Id,
                outStock: soDetail.out_stock,
                docNo: soDetail.Doc_No,
                refDoc: soDetail.Ref_Doc,
                isProjectItem: isProjectItem
              });
            }
          }
        }

        // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
        await deleteData("SO_D", `WHERE Doc_ID = ${formMasterList.docId}`);

        // ✅ อัปเดตค่า out_stock ทุกรายการตามที่ผู้ใช้เลือก
        const outStockValue = shouldCutStock ? 1 : 0;

        // อัปเดต formDetailList ให้มีค่า outStock ที่ถูกต้อง
        const updatedDetailList = formDetailList.map(item => ({
          ...item,
          outStock: outStockValue
        }));

        const detailPromises = updatedDetailList.map(async (item, index) => {
          const formDetailData = {
            doc_id: parseCurrency(docId, 10),
            line: index + 1,
            item_id: item.itemId || null,
            item_code:
              item.itemCode === "BOM" || item.isSpecRow ? "" : item.itemCode,
            item_name: item.itemName,
            item_qty: item.isSpecRow ? 1 : parseCurrency(item.itemQty), // Spec = 1 เสมอ
            item_unit: item.isSpecRow ? "" : item.itemUnit,
            item_price_unit: item.isSpecRow
              ? 0
              : parseCurrency(item.itemPriceUnit),
            item_discount: item.isSpecRow
              ? 0
              : parseCurrency(item.itemDiscount),
            item_distype: item.isSpecRow
              ? 1
              : item.itemDisType,
            item_total: item.isSpecRow ? 0 : parseCurrency(item.itemTotal),
            item_status: parseCurrency("1"),
            ds_seq: item.dsSeq,
            wh_id: item.whId,
            out_stock: outStockValue, // ใช้ค่าจาก dialog ที่ผู้ใช้เลือก (1=ตัดสต๊อก, 0=ไม่ตัดสต๊อก)
          };

          return Axios.post(
            `${process.env.REACT_APP_API_URL}/api/create-so-d`,
            formDetailData,
            {
              headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
            }
          );
        });

        await Promise.all(detailPromises);

        // ✅ ถ้าผู้ใช้เลือกไม่ตัดสต๊อก ให้ข้ามขั้นตอนนี้
        if (!shouldCutStock) {
        } else {
          // 📊 สร้าง Map ของข้อมูลใหม่ (พร้อมตรวจสอบ BOM status)
          const newItemMap = new Map();
          for (const item of updatedDetailList) {
            if (item.itemId && item.itemCode && !item.isSpecRow && !item.isBOMChild && item.itemCode !== "BOM") {
              const key = `${item.itemId}|${item.whId}`;
              const qty = parseCurrency(item.itemQty);

              // ตรวจสอบ BOM status (ถ้ายังไม่มีค่า isProjectItem)
              let isProjectItem = item.isProjectItem;
              if (isProjectItem === undefined || isProjectItem === null) {
                try {
                  const itemData = await getData(
                    "Tb_Set_Item",
                    `Item_Id = ${item.itemId}`
                  );
                  if (itemData && itemData.length > 0) {
                    isProjectItem = itemData[0].Is_BOM === "Y";
                  }
                } catch (error) {
                  console.warn("ไม่สามารถดึงข้อมูล BOM สำหรับ Item_Id:", item.itemId);
                  isProjectItem = false;
                }
              }

              newItemMap.set(key, {
                itemId: item.itemId,
                itemCode: item.itemCode,
                itemName: item.itemName,
                qty: qty,
                whId: item.whId,
                isProjectItem: isProjectItem
              });
            }
          }

          // 🔄 คำนวณการเปลี่ยนแปลงจำนวนสินค้า
          const stockAdjustments = new Map();

          // ตรวจสอบรายการเก่าที่ถูกลบหรือลดจำนวน
          for (const [key, oldItem] of oldItemMap.entries()) {
            if (oldItem.outStock === 1) { // เฉพาะที่เคยตัดสต๊อก
              const newItem = newItemMap.get(key);

              if (!newItem) {
                // รายการถูกลบ → คืนสต๊อกทั้งหมด

                if (!stockAdjustments.has(key)) {
                  stockAdjustments.set(key, { IN: 0, OUT: 0, item: oldItem });
                }
                stockAdjustments.get(key).IN += oldItem.qty;
              } else if (newItem.qty !== oldItem.qty) {
                // จำนวนเปลี่ยนแปลง
                const qtyDiff = newItem.qty - oldItem.qty;

                if (!stockAdjustments.has(key)) {
                  stockAdjustments.set(key, { IN: 0, OUT: 0, item: newItem });
                }

                if (qtyDiff > 0) {
                  // เพิ่มจำนวน → ตัดสต๊อกเพิ่ม
                  stockAdjustments.get(key).OUT += qtyDiff;
                } else {
                  // ลดจำนวน → คืนสต๊อก
                  stockAdjustments.get(key).IN += Math.abs(qtyDiff);
                }
              }
            }
          }

          // ตรวจสอบรายการใหม่ที่ถูกเพิ่ม
          for (const [key, newItem] of newItemMap.entries()) {
            if (!oldItemMap.has(key)) {
              // รายการใหม่ → ตัดสต๊อก
              console.debug("➕ รายการใหม่ - ตัดสต๊อก:", {
                itemCode: newItem.itemCode,
                qty: newItem.qty
              });

              if (!stockAdjustments.has(key)) {
                stockAdjustments.set(key, { IN: 0, OUT: 0, item: newItem });
              }
              stockAdjustments.get(key).OUT += newItem.qty;
            }
          }

          // 🔄 ดำเนินการปรับสต๊อก (เฉพาะรายการที่มีการเปลี่ยนแปลง)
          for (const [key, adjustment] of stockAdjustments.entries()) {
            const item = adjustment.item;

            // คืนสต๊อก (IN)
            if (adjustment.IN > 0) {
              // ตรวจสอบว่าเป็น BOM หรือไม่
              if (item.isProjectItem) {
                // เป็น BOM → คืนสต๊อกของ BOM components
                const bomList = await calculateBomStockRecursive(
                  item.itemId,
                  adjustment.IN,
                  item.whId
                );

                console.debug("🔄 คืนสต๊อก BOM components:", bomList);

                for (const b of bomList) {
                  await manageWhItemData(
                    b.Item_Id,
                    b.Item_Code,
                    b.Item_Name,
                    item.whId,
                    "IN",
                    b.Qty,
                    docId,
                    formMasterList.docNo,
                    formMasterList.refDoc === null ? formMasterList.docNo : formMasterList.refDoc,
                    `คืนสต๊อก BOM จากการแก้ไขใบกำกับภาษี (ลด/ลบ)`
                  );
                }
              } else {
                // สินค้าทั่วไป → คืนสต๊อก
                await manageWhItemData(
                  item.itemId,
                  item.itemCode,
                  item.itemName,
                  item.whId,
                  "IN",
                  adjustment.IN,
                  docId,
                  formMasterList.docNo,
                  formMasterList.refDoc === null ? formMasterList.docNo : formMasterList.refDoc,
                  `คืนสต๊อกจากการแก้ไขใบกำกับภาษี (ลด/ลบ)`
                );
              }
            }

            // ตัดสต๊อก (OUT)
            if (adjustment.OUT > 0) {
              // ตรวจสอบว่าเป็น BOM หรือไม่
              if (item.isProjectItem) {
                // เป็น BOM → ตัดสต๊อกของ BOM components
                const bomList = await calculateBomStockRecursive(
                  item.itemId,
                  adjustment.OUT,
                  item.whId
                );

                console.debug("✂️ ตัดสต๊อก BOM components:", bomList);

                for (const b of bomList) {
                  await manageWhItemData(
                    b.Item_Id,
                    b.Item_Code,
                    b.Item_Name,
                    item.whId,
                    "OUT",
                    b.Qty,
                    docId,
                    formMasterList.docNo,
                    formMasterList.refDoc === null ? formMasterList.docNo : formMasterList.refDoc,
                    `ตัดสต๊อก BOM จากการแก้ไขใบกำกับภาษี (เพิ่ม)`
                  );
                }
              } else {
                // สินค้าทั่วไป → ตัดสต๊อก
                await manageWhItemData(
                  item.itemId,
                  item.itemCode,
                  item.itemName,
                  item.whId,
                  "OUT",
                  adjustment.OUT,
                  docId,
                  formMasterList.docNo,
                  formMasterList.refDoc === null ? formMasterList.docNo : formMasterList.refDoc,
                  `ตัดสต๊อกจากการแก้ไขใบกำกับภาษี (เพิ่ม)`
                );
              }
            }
          }
        } // ปิด if (shouldCutStock)

        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  const handleUpdatePayment = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่าว่าเลือกประเภทการชำระเงินหรือยัง
      if (!paymentType) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกประเภทการชำระเงิน");
        return; // หยุดการทำงานของฟังก์ชันหากไม่ได้เลือกประเภทการชำระเงิน
      }

      let docStatusPaid;
      const totalPaidAmount =
        (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
        (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
        (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
        (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
        (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

      if (parseCurrency(totalPaidAmount) === 0) {
        getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
        setIsLoading(false);
        return;
      }

      if (paymentType.credit || paymentType.unpaid) {
        docStatusPaid = 2; // ค้างจ่าย
      } else if (parseCurrency(totalPaidAmount) < parseCurrency(grandTotal)) {
        docStatusPaid = 2; // ค้างจ่าย
      } else {
        docStatusPaid = 3; // จ่ายครบ
      }

      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) =>
          paymentType[method] && parseCurrency(paymentAmount[method]) > 0
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }

      if (mode === "I") {
        await handleSubmit(docStatusPaid, docStatusPaidType, totalPaidAmount);
        // callInitialize();
        // getAlert("OK", "บันทึกรายการใบขายสำเร็จ");
      } else {
        // เอายอดเดิมก่อนที่จะแก้ไข มาทำการจ่ายคืนสต็อกก่อน
        const getOldData = await getDataWithComp(
          "API_0701_SO_H",
          `AND Doc_ID = ${formMasterList.docId}`
        );
        if (getOldData && getOldData.length > 0) {
          const data = getOldData[0];
          // ปรับยอดเงินออก
          await manageWhArPaymentData(
            data.AR_ID, // AR_ID ของลูกค้านั้นๆ
            data.AR_Code, // AR_Code ของสิ่งนั้นๆ
            data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
            0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
            "AO", // ประเภท เช่น AI/AO
            data.Pay_Total, // ค่าจำนวนเงิน
            data.Doc_ID, // ไอดีเอกสาร
            data.Doc_No, // เลขเอกสาร
            data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
            `แก้ไขการชำระเงินใบขาย : ${data.Doc_No}` // หมายเหตุ
          );
        }

        const formPaidData = {
          doc_status: parseCurrency("2"),
          doc_status_paid: parseCurrency(docStatusPaid),
          doc_status_paid_type: parseCurrency(docStatusPaidType),
          update_date: formatThaiDateUiToDate(getCreateDateTime()),
          update_by_name: window.localStorage.getItem("name"),
          update_by_id: window.localStorage.getItem("emp_id"),
          doc_no: formMasterList.docNo,
          comp_id: window.localStorage.getItem("company"),
          doc_paid_pic: base64Image,
          pay_total: parseCurrency(
            paymentType.credit || paymentType.unpaid ? "0" : totalPaidAmount
          ),
        };
        const response = await Axios.post(
          `${process.env.REACT_APP_API_URL}/api/update-so-paid`,
          formPaidData,
          {
            headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
          }
        );
        if (response.data.status === "OK") {
          const docId = parseCurrency(formMasterList.docId, 10);

          const paymentTypeMap = {
            cash: 1,
            transfer: 2,
            cheque: 3,
            credit: 4,
            unpaid: 5,
          };

          // ลบข้อมูลเดิมก่อนจะเริ่มการบันทึกใหม่
          await deleteData(
            "Pay_History",
            `WHERE DocCode_Id = 7 AND Doc_Id = ${docId}`
          );

          for (const method of Object.keys(paymentType)) {
            if (
              paymentType[method] &&
              parseCurrency(paymentAmount[method]) > 0 &&
              (paymentTypeMap[method] === 1 ||
                paymentTypeMap[method] === 2 ||
                paymentTypeMap[method] === 3)
            ) {
              const formPaymentHistoryData = {
                doc_code_id: 7,
                doc_id: docId,
                pay_type: paymentTypeMap[method],
                pay_amount:
                  docStatusPaidType === 6
                    ? parseCurrency(paymentAmount[method])
                    : parseCurrency(totalPaidAmount),
                pay_remark: null,
                pay_datetime: getCreateDateTime2(),
                pay_by: localStorage.getItem("name"),
                pay_to_acc_no: null,
                pay_to_branch: null,
                pay_to_acc_name: null,
                pay_cheque_no: paymentTypeMap[method] === 3 ? chequeNo : null,
                pay_cheque_name:
                  paymentTypeMap[method] === 3 ? chequeName : null,
                pay_cheque_branch:
                  paymentTypeMap[method] === 3 ? chequeBranch : null,
                pay_cheque_type: null,
              };

              // ส่งข้อมูลไปยัง API
              await Axios.post(
                `${process.env.REACT_APP_API_URL}/api/create-pay-history`,
                formPaymentHistoryData,
                {
                  headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
                }
              );
            }
          }

          // ค้นหาข้อมูลล่าสุด และทำการอัพเดตค่าใน PAYMENT_ONHAND & PAYMENT_STC
          if (paymentType.cash || paymentType.transfer || paymentType.cheque) {
            const getNewData = await getDataWithComp(
              "API_0701_SO_H",
              `AND Doc_ID = ${formMasterList.docId}`
            );
            if (getNewData && getNewData.length > 0) {
              const data = getNewData[0];
              if (data.Doc_Status_Paid_Type === 6) {
                const getPayHistory = await getData(
                  "Pay_History",
                  `DocCode_Id = 7 AND Doc_Id = ${docId}`
                );
                if (getPayHistory && getPayHistory.length > 0) {
                  for (const pay of getPayHistory) {
                    await manageWhArPaymentData(
                      data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                      data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                      data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                      0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                      "AI", // ประเภท เช่น AI/AO
                      pay.Pay_Amount, // ค่าจำนวนเงิน
                      data.Doc_ID, // ไอดีเอกสาร
                      data.Doc_No, // เลขเอกสาร
                      data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                      await setRemarkByPaymentType(parseCurrency(pay.Pay_Type)) // หมายเหตุ
                    );
                  }
                }
              } else {
                // ปรับยอดเงินออก
                await manageWhArPaymentData(
                  data.AR_ID, // AR_ID ของลูกค้านั้นๆ
                  data.AR_Code, // AR_Code ของสิ่งนั้นๆ
                  data.AR_Name, // ชื่อลูกค้าคนนั้นๆ
                  0, // WarehouseID (Default ไว้ที่ 0 เสมอ)
                  "AI", // ประเภท เช่น AI/AO
                  data.Pay_Total, // ค่าจำนวนเงิน
                  data.Doc_ID, // ไอดีเอกสาร
                  data.Doc_No, // เลขเอกสาร
                  data.Ref_Doc === null ? data.Doc_No : data.Ref_Doc, // เลขเอกสารอ้างอิง
                  await setRemarkByPaymentType(
                    parseCurrency(data.Doc_Status_Paid_Type)
                  ) // หมายเหตุ
                );
              }
            }
          }

          setIsLoading(false);
          callInitialize();
          getAlert(response.data.status, response.data.message);
        }
      }

      // callInitialize();
      // getAlert("OK", "บันทึกรายการใบขายสำเร็จ");
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };
  // ใช้สำหรับปรับสถานะที่เป็น 'ค้างจ่าย' ให้เป็น 'จ่ายครบ' (เฉพาะเครดิต และ เช็ค)
  const handleUpdatePaidStatus = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);
      // ตรวจสอบช่องทางที่ถูกเลือก
      let docStatusPaidType = 6;
      const selectedMethods = Object.keys(paymentType).filter(
        (method) => paymentType[method]
      );

      if (selectedMethods.length === 1) {
        const method = selectedMethods[0];
        const paymentTypeMap = {
          cash: 1,
          transfer: 2,
          cheque: 3,
          credit: 4,
          unpaid: 5,
        };
        docStatusPaidType = paymentTypeMap[method] || 6;
      }
      // ข้อมูลหลักที่จะส่งไปยัง API
      const formUpdateData = {
        doc_status_paid: parseCurrency("3", 10),
        update_date: formatThaiDateUiToDate(getCreateDateTime()),
        update_by_name: window.localStorage.getItem("name"),
        update_by_id: window.localStorage.getItem("emp_id"),
        doc_no: formMasterList.docNo,
        comp_id: window.localStorage.getItem("company"),
        doc_status_paid_type: parseCurrency(docStatusPaidType, 10),
      };
      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-paid-complete`,
        formUpdateData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );
      // ตรวจสอบสถานะการตอบกลับ
      if (response.data.status === "OK") {
        // callInitialize();
        // getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
      // handlePayTypeShow();
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleCancel = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        doc_no: formMasterList.docNo,
        doc_status: parseCurrency("13", 10),
        cancel_date: formatThaiDateUiToDate(getCreateDateTime()),
        cancel_by_name: window.localStorage.getItem("name"),
        cancel_by_id: window.localStorage.getItem("emp_id"),
        comp_id: window.localStorage.getItem("company"),
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/cancel-so-h`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // คืนสต็อกคลัง เมื่อทำการยกเลิก (คุณทรายแจ้งมา)
      const findOldDetail = await getDataWithComp(
        "API_0702_SO_D",
        `AND Doc_No = '${formMasterList.docNo}' ORDER By Line ASC`
      );
      if (findOldDetail && findOldDetail.length > 0) {
        for (const dataDetail of findOldDetail) {
          // ✅ เช็คว่าสินค้านั้นมีการตัดสต๊อกหรือไม่
          if (dataDetail.Item_Code && dataDetail.out_stock === 1) {
            // ย้ายเข้า (คืนสต๊อก)
            await manageWhItemData(
              dataDetail.Item_Id, // Item ไอดีของสิ่งนั้นๆ
              dataDetail.Item_Code, // Item โค้ดของสิ่งนั้นๆ
              dataDetail.Item_Name, // ชื่อ Item นั้นๆ
              dataDetail.WH_Id, // WarehouseID ของไอเทม
              "AI", // ประเภท เช่น IN/OUT/AI/AO/TI/TO
              parseCurrency(dataDetail.Item_Qty), // ค่าจำนวนที่กรอกจากหน้าจอ
              dataDetail.Doc_ID, // ไอดีเอกสาร
              dataDetail.Doc_No, // เลขเอกสาร
              dataDetail.Ref_Doc === null
                ? dataDetail.Doc_No
                : dataDetail.Ref_Doc, // เลขเอกสารอ้างอิง
              `ยกเลิกใบ : ${dataDetail.Doc_No}` // หมายเหตุ
            );
          }
        }
      }

      callInitialize();
      getAlert(response.data.status, response.data.message);

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleUpdateSlip = async () => {
    try {
      // สำหรับ Freeze หน้าจอตอนทำรายการ
      setIsLoading(true);

      // ตรวจสอบค่า formMasterList.arID และ formMasterList.arCode
      if (!formMasterList.arID && !formMasterList.arCode) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเลือกลูกค้า");
        return; // หยุดการทำงานของฟังก์ชันหากไม่มีค่า arID หรือ arCode
      }

      // ตรวจสอบว่า formDetailList มีค่าหรือมีความยาวเป็น 0
      if (!formDetailList || formDetailList.length === 0) {
        setIsLoading(false);
        getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
        return; // หยุดการทำงานของฟังก์ชันหาก formDetailList ไม่มีค่า
      }

      // ตรวจสอบค่าภายใน formDetailList
      for (const item of formDetailList) {
        if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากจำนวนของสินค้าเป็น 0 หรือไม่มีค่า
        }
        if (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0) {
          setIsLoading(false);
          getAlert("FAILED", `กรุณากรอกราคาต่อหน่วยของสินค้า ${item.itemName}`);
          return; // หยุดการทำงานหากราคาต่อหน่วยเป็น 0 หรือไม่มีค่า
        }
        if (!item.whId) {
          setIsLoading(false);
          getAlert(
            "FAILED",
            `ไม่สามารถบันทึกได้เนื่องจากไม่พบคลังสินค้าของสินค้า ${item.itemName}`
          );
          return; // หยุดการทำงานหาก whId เป็น 13 หรือไม่มีค่า
        }
      }

      // ข้อมูลหลักที่จะส่งไปยัง API
      const formMasterData = {
        comp_id: window.localStorage.getItem("company"),
        doc_no: maxDocNo,
        doc_paid_pic: base64Image,
      };

      // ส่งข้อมูลหลักไปยัง API
      const response = await Axios.post(
        `${process.env.REACT_APP_API_URL}/api/update-so-h-slip`,
        formMasterData,
        {
          headers: { key: process.env.REACT_APP_ANALYTICS_KEY },
        }
      );

      // ตรวจสอบสถานะการตอบกลับ
      if (mode !== "I" && response.data.status === "OK") {
        callInitialize();
        getAlert(response.data.status, response.data.message);
      }

      setIsLoading(false);
    } catch (error) {
      setIsLoading(false);
      getAlert("FAILED", error.response?.data?.message || error.message);
    }
  };

  const handleChangeMaster = (e) => {
    const { name, value } = e.target;
    // อัปเดตค่าใน formMasterList
    setFormMasterList((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleChangeDateMaster = (value, name) => {
    const newValue =
      value && value instanceof moment
        ? value.format("DD-MM-YYYY") // รูปแบบ DD-MM-YYYY (พ.ศ.)
        : value;
    console.log("handleChangeDateMaster", newValue, name);
    setFormMasterList((prev) => ({
      ...prev,
      [name]: newValue,
    }));
    console.log(formMasterList.docDate);
  };

  const handleChangeDetail = async (index, field, value) => {
    // ป้องกันการแก้ไข Spec row
    const item = formDetailList[index];
    if (item && item.isSpecRow) {
      // Spec row ห้ามแก้ไข itemQty, itemPriceUnit, itemDiscount
      if (["itemQty", "itemPriceUnit", "itemDiscount", "itemDisType"].includes(field)) {
        return; // ไม่ทำอะไร
      }
    }

    const numericFields = ["itemQty", "itemPriceUnit", "itemDiscount"];
    if (numericFields.includes(field) && !/^\d*\.?\d*$/.test(value)) {
      return;
    }

    let updatedList = [...formDetailList];
    updatedList[index][field] = value;

    if (field === "whId") {
      updatedList[index].itemOnHand = "-";

      const [itemOnHand] = await Promise.all([
        getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parseCurrency(value)} AND Item_Id = ${updatedList[index].itemId
          }`
        ),
      ]);

      let newItemOnHand = 0;
      if (itemOnHand && itemOnHand.length > 0) {
        newItemOnHand = parseCurrency(itemOnHand[0].Item_Onhand);
      }
      const itemQty = parseFloat(updatedList[index].itemQty) || 0;

      // ✅ เงื่อนไขเพิ่ม: ถ้าไม่ใช่สินค้าโปรเจค → ตรวจสอบและเซ็ต 0 ได้
      // if (!updatedList[index].isProjectItem && itemQty > newItemOnHand) {
      //   updatedList[index].itemQty = formatCurrency("0.00"); // Reset เฉพาะที่ไม่ใช่โปรเจค
      // }

      updatedList[index].itemOnHand = newItemOnHand;
    }

    if (numericFields.includes(field) || field === "itemQty") {
      const itemQty = parseFloat(updatedList[index].itemQty) || 0;
      const itemPriceUnit =
        parseFloat(parseCurrency(updatedList[index].itemPriceUnit)) || 0;
      const itemDiscount =
        parseFloat(parseCurrency(updatedList[index].itemDiscount)) || 0;
      const itemDisType = String(updatedList[index].itemDisType);

      let itemTotal = itemQty * itemPriceUnit;

      if (itemDisType === "2") {
        itemTotal -= (itemDiscount / 100) * itemTotal;
      } else {
        itemTotal -= itemDiscount;
      }

      updatedList[index].itemTotal = itemTotal;

      // ✅ ถ้าเป็นโหมด Edit และแก้ไข itemQty และ out_stock = 1 → ตัดสต็อก
      if (mode === "U" && field === "itemQty" && updatedList[index].outStock === 1) {
        const currentItem = formDetailList[index]; // ข้อมูลเดิม
        const oldQty = parseFloat(parseCurrency(currentItem.itemQty)) || 0;
        const newQty = itemQty;
        const qtyDiff = newQty - oldQty; // ผลต่างจำนวนที่เปลี่ยน

        if (qtyDiff !== 0 && currentItem.itemCode && currentItem.whId) {
          // ถ้าเพิ่มจำนวน (qtyDiff > 0) → ตัดสต็อกเพิ่ม (OUT)
          // ถ้าลดจำนวน (qtyDiff < 0) → คืนสต็อก (IN)
          const moveType = qtyDiff > 0 ? "OUT" : "IN";
          const absQtyDiff = Math.abs(qtyDiff);

          try {
            await manageWhItemData(
              currentItem.itemId,
              currentItem.itemCode,
              currentItem.itemName,
              currentItem.whId,
              moveType,
              absQtyDiff,
              formMasterList.docId,
              formMasterList.docNo,
              formMasterList.refDoc || formMasterList.docNo,
              "แก้ไขจำนวนสินค้าในใบขาย"
            );

            // อัปเดต itemOnHand หลังตัดสต็อก
            const [itemOnHand] = await Promise.all([
              getDataWithComp(
                "API_1101_WH_ITEM_ONHAND",
                `AND WH_Id = ${parseCurrency(currentItem.whId)} AND Item_Id = ${currentItem.itemId}`
              ),
            ]);

            if (itemOnHand && itemOnHand.length > 0) {
              updatedList[index].itemOnHand = parseCurrency(itemOnHand[0].Item_Onhand);
            }
          } catch (error) {
            console.error("❌ ปรับสต๊อกผิดพลาด:", error);
            getAlert("FAILED", "เกิดข้อผิดพลาดในการปรับสต๊อก: " + error.message);
          }
        }
      }

      // ✅ ถ้าเป็น Project (Group 3 / หัวโปรเจกต์) → กระจาย qty ไปยังลูก BOM
      // if (updatedList[index].isProjectItem === true) {
      //   const parentId = updatedList[index].itemId;

      //   const bomList = await getDataWithComp(
      //     "Tb_Set_ItemBOM",
      //     `AND pro_id = ${parentId}`
      //   );

      //   updatedList = updatedList.map((item) => {
      //     if (item.itemId === parentId) return item;

      //     const bomItem = bomList.find((b) => b.item_id === item.itemId);
      //     if (bomItem) {
      //       const newQty =
      //         parseCurrency(bomItem.quantity || 0) * parseCurrency(itemQty);
      //       return {
      //         ...item,
      //         itemQty: formatCurrency(newQty),
      //         itemTotal: 0, // ให้ user กรอกราคาหรือคำนวณเองภายหลัง
      //       };
      //     }
      //     return item;
      //   });
      // }
    }

    setFormDetailList(updatedList);
  };

  const handleFocus = (index, field) => {
    const updatedList = [...formDetailList];
    const currentValue = updatedList[index][field];

    const stringValue =
      typeof currentValue === "string"
        ? currentValue
        : currentValue?.toString() || "";

    updatedList[index][field] = parseFloat(stringValue.replace(/,/g, "")) || 0;
    setFormDetailList(updatedList);
  };

  const handleBlur = (index, field, value) => {
    const numericValue = parseFloat(value.replace(/,/g, "")) || 0;
    const formattedValue = formatCurrency(numericValue);

    const updatedList = [...formDetailList];
    updatedList[index][field] = formattedValue;
    setFormDetailList(updatedList);
  };

  // SET QT
  const [showQtModal, setShowQtModal] = useState(false);
  const handleQtShow = () => setShowQtModal(true);
  const handleQtClose = () => setShowQtModal(false);
  const onRowSelectQt = async (qtSelected) => {
    try {
      // เคลียร์ค่าใน formMasterList และ formDetailList
      setFormMasterList({});
      setFormDetailList([]);

      // ค้นหาข้อมูลที่ตรงกับ prSelected.Doc_No ใน PR_H และ AP_ID ใน apDataList
      const [fromViewMaster, fromViewAr] = await Promise.all([
        getDataWithComp("API_0601_QT_H", "ORDER BY Doc_No DESC"),
        arDataList.find((ar) => ar.AR_Id === qtSelected.AR_ID),
      ]);

      const fromViewQt = fromViewMaster.find(
        (qt) => qt.Doc_No === qtSelected.Doc_No
      );

      if (!fromViewQt || !fromViewAr) {
        throw new Error("ไม่พบข้อมูล");
      }

      // ฟังก์ชันเพื่อสร้างโมเดลใหม่สำหรับแต่ละแถวและคำนวณ itemTotal
      const createNewRow = (index, itemSelected) => {
        const itemQty = parseCurrency(itemSelected.Item_Qty) || 0;
        const itemPriceUnit = parseCurrency(itemSelected.Item_Price_Unit) || 0;
        const itemDiscount = parseCurrency(itemSelected.Item_Discount) || 0;
        let itemTotal = itemQty * itemPriceUnit;

        if (itemSelected.Item_DisType === 2) {
          itemTotal -= (itemDiscount / 100) * itemTotal; // ลดตามเปอร์เซ็นต์
        } else {
          itemTotal -= itemDiscount; // ลดตามจำนวนเงิน
        }

        return {
          ...soDetailModel(index + 1),
          line: itemSelected.Line,
          itemId: itemSelected.Item_Id,
          itemCode: itemSelected.Item_Code,
          itemName: itemSelected.Item_Name,
          itemQty,

          itemUnit: itemSelected.Item_Unit,
          itemPriceUnit: formatCurrency(itemPriceUnit),
          itemDiscount: formatCurrency(itemDiscount),
          itemDisType: String(itemSelected.Item_DisType),
          itemTotal,
          itemStatus: itemSelected.Item_Status,
          whId: itemSelected.WH_ID,
          whName: itemSelected.WH_Name,
          zoneId: itemSelected.Zone_ID,
          ltId: itemSelected.LT_ID,
          dsSeq: itemSelected.DS_SEQ,
        };
      };

      const getAllItem = await getDataWithComp(
        "API_0602_QT_D",
        "ORDER BY Line ASC"
      );
      const filterItem = getAllItem.filter(
        (item) => item.Doc_No === qtSelected.Doc_No
      );

      if (filterItem.length > 0) {
        const newFormDetails = filterItem.map((item, index) =>
          createNewRow(formDetailList.length + index, item)
        );


        setFormDetailList(newFormDetails);

        const firstItem = filterItem[0];

        setFormMasterList({
          ...formMasterList,
          refDocID: fromViewQt.Doc_ID,
          refDoc: fromViewQt.Doc_No,
          refDocDate: formatThaiDateUi(fromViewQt.Doc_Date),
          docDate: formatThaiDateUi(moment()),
          docRemark1: fromViewQt.Doc_Remark1,
          docRemark2: fromViewQt.Doc_Remark2,
          docType: fromViewQt.Doc_Type,
          docFor: fromViewQt.Doc_For,
          transportType: fromViewQt.Transport_Type,
          discountValue: fromViewQt.Discount_Value,
          creditTerm: firstItem.CreditTerm,
          arID: fromViewQt.AR_ID,
          arCode: firstItem.AR_Code,
          arName: firstItem.AR_Name,
          arAdd1: firstItem.AR_Add1,
          arAdd2: firstItem.AR_Add2,
          arAdd3: firstItem.AR_Add3,
          arProvince: firstItem.AR_Province,
          arZipcode: firstItem.AR_Zipcode,
          arTaxNo: firstItem.AR_TaxNo,
          arItemFree: firstItem.AR_Item_Free,
          saleName: fromViewAr.AR_RefSaleName,
        });

        // Fetch and set delivery address for the customer from the quotation
        const transportData = await getData(
          "Tb_Set_ARTransport",
          `AR_Id = ${fromViewQt.AR_ID}`
        );
        setTransportList(transportData || []);

        if (transportData && transportData.length > 0) {
          const defaultData =
            transportData.find((d) => d.SetDefault === "Y") || transportData[0];

          const tel1 =
            defaultData.Tel1 && defaultData.Contact1
              ? `${defaultData.Tel1} (${defaultData.Contact1})`
              : defaultData.Tel1
                ? defaultData.Tel1
                : defaultData.Contact1
                  ? `(${defaultData.Contact1})`
                  : "";

          const tel2 =
            defaultData.Tel2 && defaultData.Contact2
              ? `${defaultData.Tel2} (${defaultData.Contact2})`
              : defaultData.Tel2
                ? defaultData.Tel2
                : defaultData.Contact2
                  ? `(${defaultData.Contact2})`
                  : "";

          const telCombined = [tel1, tel2].filter((t) => t).join(" / ");

          const placeDelivery = `${defaultData.Add1 || ""}`.trim();
          const placeDelivery2 = `${defaultData.Add2 || ""}`.trim();
          const placeDelivery3 = `${defaultData.Add3 || ""} ${defaultData.Province || ""} ${defaultData.Zip_Code || ""} ${telCombined}`.trim();

          setFormMasterList((prev) => ({
            ...prev,
            placeDelivery,
            placeDelivery2,
            placeDelivery3,
          }));
        } else {
          setFormMasterList((prev) => ({
            ...prev,
            placeDelivery: "",
            placeDelivery2: "",
            placeDelivery3: "",
          }));
        }

        if (fromViewAr.AR_Credit === 1) {
          const creditTermDays = Number(fromViewAr.AR_Credit_Term || 0);

          setPaymentType({
            cash: false,
            transfer: false,
            cheque: false,
            credit: true,
            unpaid: false,
          });

          const dateSend = moment().add(creditTermDays, "days");
          console.debug("dateSend", dateSend);
          setFormMasterList((prev) => ({
            ...prev,
            dateSend: dateSend.format("YYYY-MM-DD"),
            doc_due_date: dateSend.format("YYYY-MM-DD"),
            credit_Term: creditTermDays,
          }));
        }

        setIsVatChecked(fromViewQt.IsVat === 1 ? true : false);

        const discountValueType = parseCurrency(fromViewQt.Discount_Value_Type);
        if (!isNaN(discountValueType)) {
          setSelectedDiscountValueType(discountValueType.toString());
        }
      } else {
        getAlert(
          "FAILED",
          `ไม่พบข้อมูลที่ตรงกับเลขที่เอกสาร ${qtSelected.Doc_No} กรุณาตรวจสอบและลองอีกครั้ง`
        );
      }
      // Update warehouse for all existing items
      for (let index = 0; index < formDetailList.length; index++) {
        await handleChangeDetail(index, "whId", 5);
      }
      handleQtClose();

    } catch (error) {
      getAlert("FAILED", error.message || error);
    }
  };

  // SET AR
  const [showArModal, setShowArModal] = useState(false);
  const handleArShow = () => setShowArModal(true);
  const handleArClose = () => setShowArModal(false);
  const onRowSelectAr = async (arSelected) => {
    console.debug("onRowSelectAr", arSelected);
    try {
      if (!arSelected) return;
      setFormMasterList((prev) => ({
        ...prev,
        placeDelivery: "",
        placeDelivery2: "",
        placeDelivery3: "",
      }));
      const transportData = await getData(
        "Tb_Set_ARTransport",
        `AR_Id = ${arSelected.AR_Id}`
      );
      setTransportList(transportData || []);
      const baseData = {
        arID: arSelected.AR_Id,
        arCode: arSelected.AR_Code,
        arName: arSelected.AR_Name,
        arAdd1: arSelected.AR_Add1,
        arAdd2: arSelected.AR_Add2,
        arAdd3: arSelected.AR_Add3,
        arProvince: arSelected.AR_Province,
        arZipcode: arSelected.AR_Zipcode,
        arTaxNo: arSelected.AR_TaxNo,
        arItemFree: arSelected.AR_Item_Free,
        saleName: arSelected.AR_RefSaleName || null,
        credit: arSelected.AR_Credit === 1 ? true : false,
        credit_Term: arSelected.AR_Credit === 1 ? arSelected.AR_Credit_Term : "",
      };

      // ตรวจสอบที่อยู่ใน Set_AR_INVAddress (ตามความต้องการ: กรณีสร้างใหม่ ค้นหาข้อมูลที่อยู่ใน Set_AR_INVAddress ก่อน)
      const invAddress = await getDataWithComp(
        "Set_AR_INVAddress",
        `AND AR_ID = ${arSelected.AR_Id}`
      );

      // กรณีมีข้อมูลใน Set_AR_INVAddress → ใช้ที่อยู่จาก Set_AR_INVAddress
      if (invAddress && invAddress.length > 0) {
        baseData.arAdd1 = invAddress[0].AR_Address1;
        baseData.arAdd2 = invAddress[0].AR_Address2;
        baseData.arAdd3 = invAddress[0].AR_Address3;

        // ตรวจสอบที่อยู่จัดส่งใน Set_AR_INVAddress ก่อน
        if (invAddress[0].AR_Delivery1 || invAddress[0].AR_Delivery2 || invAddress[0].AR_Delivery3) {
          baseData.placeDelivery = invAddress[0].AR_Delivery1 || "";
          baseData.placeDelivery2 = invAddress[0].AR_Delivery2 || "";
          baseData.placeDelivery3 = invAddress[0].AR_Delivery3 || "";
        }
      }
      // หมายเหตุ: ถ้าไม่มีข้อมูลใน Set_AR_INVAddress → ใช้ที่อยู่จาก Master (Set_AR) ซึ่งถูกกำหนดไว้ใน baseData แล้ว

      // ถ้าไม่มีที่อยู่จัดส่งจาก Set_AR_INVAddress ให้ใช้จาก Tb_Set_ARTransport
      if (!baseData.placeDelivery && transportData && transportData.length > 0) {
        const defaultData =
          transportData.find((d) => d.SetDefault === "Y") || transportData[0];

        const tel1 =
          defaultData.Tel1 && defaultData.Contact1
            ? `${defaultData.Tel1} (${defaultData.Contact1})`
            : defaultData.Tel1
              ? defaultData.Tel1
              : defaultData.Contact1
                ? `(${defaultData.Contact1})`
                : "";

        const tel2 =
          defaultData.Tel2 && defaultData.Contact2
            ? `${defaultData.Tel2} (${defaultData.Contact2})`
            : defaultData.Tel2
              ? defaultData.Tel2
              : defaultData.Contact2
                ? `(${defaultData.Contact2})`
                : "";

        const telCombined = [tel1, tel2].filter((t) => t).join(" / ");

        baseData.placeDelivery = `${defaultData.Add1 || ""}`.trim();
        baseData.placeDelivery2 = `${defaultData.Add2 || ""}`.trim();
        baseData.placeDelivery3 = `${defaultData.Add3 || ""} ${defaultData.Province || ""} ${defaultData.Zip_Code || ""} ${telCombined}`.trim();
      }

      if (arSelected.AR_Credit === 1) {
        const creditTermDays = Number(arSelected.AR_Credit_Term || 0);
        const dateSend = moment().add(creditTermDays, "days");

        baseData.dateSend = dateSend.format("YYYY-MM-DD");
        baseData.doc_due_date = dateSend.format("YYYY-MM-DD");
        baseData.credit_Term = creditTermDays;

        setPaymentType({
          cash: false,
          transfer: false,
          cheque: false,
          credit: true,
          unpaid: false,
        });
      }

      if (parseCurrency(arSelected.AR_Vat) === 1) {
        setIsVatChecked(true);
      }

      if (arSelected.AR_Item_Free === "Y") {
        if (formDetailList.length > 0) {
          setFormDetailList([]);
          getAlert("INFO", "ลูกค้านี้เป็นลูกค้าฟรี ระบบจะล้างข้อมูลรายการสินค้าโดยอัตโนมัติ");
        }
      }

      setFormMasterList((prev) => ({ ...prev, ...baseData }));

      handleArClose();
    } catch (error) {
      console.error("onRowSelectAr ERROR:", error);
      getAlert("FAILED", error.message || error);
    }
  };

  const handleAddressChange = (field, value) => {
    // Update State only
    setFormMasterList((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleDeliveryAddressChange = (field, value) => {
    // Update State only
    setFormMasterList((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  // SET ITEM
  const [showItemModal, setShowItemModal] = useState(false);
  const handleItemShow = () => setShowItemModal(true);
  const handleItemClose = () => setShowItemModal(false);

  const checkDuplicateCutStockByCustomerAndProject = async () => {
    const arID = formMasterList.arID;

    if (!arID) return false;

    // ดึงข้อมูล SO_H ที่ลูกค้าชื่อนี้และมีการตัดสต๊อกแล้ว
    const soHeaderList = await getDataWithComp(
      "SO_H",
      `AND AR_ID = ${arID} AND IsCutSTC = 'Y'`
    );

    if (!soHeaderList || soHeaderList.length === 0) return false;

    // ดึง Doc_Id ทั้งหมดจากผลลัพธ์ข้างต้น
    const docIds = soHeaderList.map((so) => so.Doc_Id);

    // ดึงข้อมูล SO_D ที่เกี่ยวข้องกับ Doc_Id พวกนั้น
    const soDetailList = await getData(
      "SO_D",
      `Doc_ID IN (${docIds.join(",")})`
    );

    // ตรวจสอบว่ามี item_id ที่ตรงกับสินค้าประเภท Project (isProjectItem === true) ที่เรากำลังเลือกอยู่หรือไม่
    const projectItemIds = formDetailList
      .filter((item) => item.isProjectItem)
      .map((item) => item.itemId);

    const matched = soDetailList?.some((soD) =>
      projectItemIds.includes(soD.Item_Id)
    );
    console.debug("matched", matched);

    return matched; // ถ้าเคยตัดแล้ว → true
  };
  const idiemDataListRef = useRef([]);
  console.debug("idiemDataListRef", idiemDataListRef.current);

  const onRowSelectItem = async (itemsSelected) => {
    try {
      console.debug("itemsSelected", itemsSelected);
      const itemsToAdd = [];
      const existingIds = new Set(formDetailList.map((item) => item.itemId));
      const idiemDataList = [...idiemDataListRef.current]; // clone เผื่ออัปเดตใหม่ภายหลัง

      for (let i = 0; i < itemsSelected.length; i++) {
        const item = itemsSelected[i];
        const itemId = item.Item_Id;
        const itemIsBOM = item.Is_BOM;
        const whId = whid;

        if (existingIds.has(itemId)) continue;

        let showBom = false;
        if (itemIsBOM === "Y") {
          const result = await Swal.fire({
            html: `
    <p style="margin-top: 10px; font-size:16px; line-height:1.6;">
          คุณต้องการแสดงรายการวัตถุดิบย่อย (BOM) สำหรับสินค้านี้หรือไม่?
          <br>
      <span style="color: #2c3e50; font-weight: bold;">${item.Item_Name}</span>

    </p>
  `,
            icon: "",
            showCancelButton: true,
            confirmButtonText: "แสดง BOM",
            cancelButtonText: "ไม่แสดง BOM",
            focusConfirm: false,
          });
          showBom = result.isConfirmed;
        }

        const onHandRes = await getDataWithComp(
          "API_1101_WH_ITEM_ONHAND",
          `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
            itemId
          )}`
        );
        const onHand =
          Array.isArray(onHandRes) && onHandRes[0]
            ? parseCurrency(onHandRes[0].Item_Onhand)
            : 0;

        // ➕ เพิ่มตัวหลัก
        itemsToAdd.push({
          line: null,
          itemId,
          itemCode: item.Item_Code,
          itemName: item.Item_Name,
          itemQty: formatCurrency(0),
          itemUnit: item.Item_Unit_ST,
          itemPriceUnit: formatCurrency(item.Item_Price || 0),
          itemDiscount: formatCurrency(0),
          itemDisType: "1",
          itemTotal: 0,
          itemStatus: item.Item_Status,
          whId,
          whName: item.WH_Name,
          zoneId: null,
          ltId: null,
          dsSeq: null,
          itemOnHand: onHand,
          isProjectItem: itemIsBOM === "Y",
          parentId: null,
          outStock: 0, // เริ่มต้น 0 จะได้จาก dialog ตอนบันทึก
        });

        // ➕ เพิ่ม Spec แถวพิเศษถ้ามี (เหมือน Quotation)
        if (item.Is_Spec_Show === "Y" && item.Item_Spec) {
          itemsToAdd.push({
            line: null,
            itemId: null,
            itemCode: "",
            itemName: item.Item_Spec,
            itemQty: formatCurrency(1), // จำนวน = 1 เสมอ
            itemUnit: "",
            itemPriceUnit: "",
            itemDiscount: "",
            itemDisType: "",
            itemTotal: "",
            itemStatus: "",
            whId: whId, // ใช้คลังเดียวกับสินค้าหลัก
            whName: item.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemOnHand: 1, // จำนวนคงคลัง = 1 เสมอ (ไม่ต้องตัด)
            isSpecRow: true,
            parentId: itemId,
            outStock: 0, // Spec ไม่ตัดสต็อก
          });
        }

        if (itemIsBOM === "Y" && showBom) {
          const bomList = await getDataWithComp(
            "Tb_Set_ItemBOM",
            `AND pro_id = ${itemId}`
          );
          if (Array.isArray(bomList)) {
            for (const bomItem of bomList) {
              const bomItemId = bomItem.item_id;

              // ❌ ข้ามถ้ามีอยู่แล้ว
              if (existingIds.has(bomItemId)) continue;

              const bomOnHandRes = await getDataWithComp(
                "API_1101_WH_ITEM_ONHAND",
                `AND WH_Id = ${parseCurrency(
                  whId
                )} AND Item_Id = ${parseCurrency(bomItemId)}`
              );
              const bomOnHand =
                Array.isArray(bomOnHandRes) && bomOnHandRes[0]
                  ? parseCurrency(bomOnHandRes[0].Item_Onhand)
                  : 0;

              const matchedItem = itemDataList.find(
                (itm) => itm.Item_Id === bomItemId
              );
              const itemName = matchedItem?.Item_Name || "";
              const itemUnit = matchedItem?.Item_Unit_IN || "";

              itemsToAdd.push({
                line: null,
                itemId: bomItemId,
                itemCode: "BOM",
                itemName,
                itemQty: formatCurrency(bomItem.quantity || 0),
                itemUnit,
                itemPriceUnit: formatCurrency(0),
                itemDiscount: formatCurrency(0),
                itemDisType: "1",
                itemTotal: 0,
                itemStatus: "Y",
                whId,
                whName: "",
                zoneId: null,
                ltId: null,
                dsSeq: null,
                itemOnHand: bomOnHand,
                isProjectItem: false,
                isBOMChild: true,
                parentId: itemId,
              });

              // อัปเดต list
              idiemDataList.push(bomItemId);
              existingIds.add(bomItemId);
            }
          }
        }

        // อัปเดต list
        idiemDataList.push(itemId);
        existingIds.add(itemId);
      }

      setFormDetailList((prev) => [...prev, ...itemsToAdd]);

      // ✅ อัปเดต Ref
      idiemDataListRef.current = Array.from(
        new Set([...idiemDataListRef.current, ...idiemDataList])
      );

      console.debug("✅ itemsToAdd", itemsToAdd);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const onRowSelectItem02 = async (selectedItems) => {
    try {
      const existingItemIds = formDetailList
        .filter((item) => item.itemId !== null)
        .map((item) => item.itemId);

      const itemsToAdd = selectedItems.filter(
        (item) => !existingItemIds.includes(item.Item_Id)
      );

      const newItems = await Promise.all(
        itemsToAdd.map(async (itemSelected) => {
          let itemOnHand = 0;
          const response = await getDataWithComp(
            "API_1101_WH_ITEM_ONHAND",
            `AND WH_Id = ${parseCurrency(whid)} AND Item_Id = ${itemSelected.Item_Id
            }`
          );

          if (response && response.length > 0) {
            itemOnHand = parseCurrency(response[0].Item_Onhand);
          }

          return {
            line: null,
            itemId: itemSelected.Item_Id,
            itemCode: itemSelected.Item_Code,
            itemName: itemSelected.Item_Name,
            itemQty: formatCurrency(0),
            itemUnit: itemSelected.Item_Unit_ST,
            itemPriceUnit: formatCurrency(itemSelected.Item_Price || 0),
            itemDiscount: formatCurrency(0),
            itemDisType: "1",
            itemTotal: 0,
            itemStatus: itemSelected.Item_Status,
            whId: whid,
            whName: itemSelected.WH_Name,
            zoneId: null,
            ltId: null,
            dsSeq: null,
            itemOnHand: itemOnHand,
          };
        })
      );

      const emptyItem = {
        line: null,
        itemId: null,
        itemCode: null,
        itemName: null,
        itemQty: formatCurrency(0),
        itemUnit: "",
        itemPriceUnit: formatCurrency(0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: 0,
        itemStatus: "Y",
        whId: whid,
        whName: "",
        zoneId: null,
        ltId: null,
        dsSeq: null,
      };

      setFormDetailList((prev) => [...prev, ...newItems, emptyItem]);
      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const onRowSelectItemForEdit = async (item, rowIndex) => {
    console.debug("item onRowSelectItemForEdit", item, rowIndex);
    try {
      const itemId = item.Item_Id;
      const itemIsBOM = item.Is_BOM;
      const whId = whid;

      let showBom = false;
      if (itemIsBOM === "Y") {
        const result = await Swal.fire({
          html: `
    <p style="margin-top: 10px; font-size:16px; line-height:1.6;">
          คุณต้องการแสดงรายการวัตถุดิบย่อย (BOM) สำหรับสินค้านี้หรือไม่?
          <br>
      <span style="color: #2c3e50; font-weight: bold;">${item.Item_Name}</span>

    </p>
  `,
          icon: "",
          showCancelButton: true,
          confirmButtonText: "แสดง BOM",
          cancelButtonText: "ไม่แสดง BOM",
          focusConfirm: false,
        });
        showBom = result.isConfirmed;
      }

      const onHandRes = await getDataWithComp(
        "API_1101_WH_ITEM_ONHAND",
        `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
          itemId
        )}`
      );
      const onHand =
        Array.isArray(onHandRes) && onHandRes[0]
          ? parseCurrency(onHandRes[0].Item_Onhand)
          : 0;

      const newItem = {
        line: null,
        itemId,
        itemCode: item.Item_Code,
        itemName: item.Item_Name,
        itemQty: formatCurrency(1),
        itemUnit: item.Item_Unit_ST,
        itemPriceUnit: formatCurrency(item.Item_Price || 0),
        itemDiscount: formatCurrency(0),
        itemDisType: "1",
        itemTotal: formatCurrency(item.Item_Price || 0),
        itemStatus: item.Item_Status,
        whId,
        whName: item.WH_Name,
        zoneId: null,
        ltId: null,
        dsSeq: null,
        itemOnHand: onHand,
        isProjectItem: itemIsBOM === "Y",
        parentId: null,
        outStock: 0, // เริ่มต้น 0 จะได้จาก dialog ตอนบันทึก
      };

      // สร้าง BOM children ถ้าผู้ใช้ยืนยัน
      let childrenToAdd = [];
      // ➕ เพิ่ม Spec แถวพิเศษถ้ามี (เหมือน Quotation)
      if (item.Is_Spec_Show === "Y" && item.Item_Spec) {
        childrenToAdd.push({
          line: null,
          itemId: null,
          itemCode: "",
          itemName: item.Item_Spec,
          itemQty: formatCurrency(1), // จำนวน = 1 เสมอ
          itemUnit: "",
          itemPriceUnit: "",
          itemDiscount: "",
          itemDisType: "",
          itemTotal: "",
          itemStatus: "",
          whId: whId, // ใช้คลังเดียวกับสินค้าหลัก
          whName: item.WH_Name,
          zoneId: null,
          ltId: null,
          dsSeq: null,
          itemOnHand: 1, // จำนวนคงคลัง = 1 เสมอ (ไม่ต้องตัด)
          isSpecRow: true,
          parentId: itemId,
          outStock: 0, // Spec ไม่ตัดสต็อก
        });
      }
      if (itemIsBOM === "Y" && showBom) {
        const bomList = await getDataWithComp(
          "Tb_Set_ItemBOM",
          `AND pro_id = ${itemId}`
        );
        if (Array.isArray(bomList)) {
          for (const bom of bomList) {
            const bomItemId = bom.item_id;
            const bomOnHandRes = await getDataWithComp(
              "API_1101_WH_ITEM_ONHAND",
              `AND WH_Id = ${parseCurrency(whId)} AND Item_Id = ${parseCurrency(
                bomItemId
              )}`
            );
            const bomOnHand =
              Array.isArray(bomOnHandRes) && bomOnHandRes[0]
                ? parseCurrency(bomOnHandRes[0].Item_Onhand)
                : 0;

            const matchedItem = itemDataList.find(
              (itm) => itm.Item_Id === bomItemId
            );
            const itemName = matchedItem?.Item_Name || "";
            const itemUnit = matchedItem?.Item_Unit_IN || "";

            childrenToAdd.push({
              line: null,
              itemId: bomItemId,
              itemCode: "BOM",
              itemName,
              itemQty: formatCurrency(bom.quantity || 0),
              itemUnit,
              itemPriceUnit: formatCurrency(0),
              itemDiscount: formatCurrency(0),
              itemDisType: "1",
              itemTotal: 0,
              itemStatus: "Y",
              whId,
              whName: "",
              zoneId: null,
              ltId: null,
              dsSeq: null,
              itemOnHand: bomOnHand,
              isProjectItem: false,
              isBOMChild: true,
              parentId: itemId,
            });
          }
        }
      }

      // 👇 แทนที่แถวเดิม และแทรก BOM ถ้ามี
      setFormDetailList((prevList) => {
        const updated = [...prevList];
        updated[rowIndex] = newItem;
        if (childrenToAdd.length > 0) {
          updated.splice(rowIndex + 1, 0, ...childrenToAdd);
        }
        return updated;
      });

      handleItemClose();
    } catch (error) {
      getAlert("FAILED", error.message || "เกิดข้อผิดพลาด");
    }
  };

  const handleDuplicateRow = (index) => {
    const newItem = { ...formDetailList[index] };
    const newList = [
      ...formDetailList.slice(0, index + 1),
      newItem,
      ...formDetailList.slice(index + 1),
    ];
    setFormDetailList(newList);
  };

  const handleRemoveRow = async (index) => {
    try {
      const itemToRemove = formDetailList[index];
      console.log("handleRemoveRow:", { index, itemToRemove, mode, outStock: itemToRemove.outStock });

      // ห้ามลบ BOM/Spec โดยตรง
      if ((itemToRemove.itemCode === "BOM" || itemToRemove.isBOMChild) && itemToRemove.itemId !== 1) {
        getAlert("FAILED", "ไม่สามารถลบรายการ BOM ได้โดยตรง ต้องลบผ่านรายการหลัก");
        return;
      }
      if (itemToRemove.isSpecRow && itemToRemove.itemId !== 1) {
        getAlert("FAILED", "ไม่สามารถลบรายการ Spec ได้โดยตรง ต้องลบผ่านรายการหลัก");
        return;
      }

      // ✅ ไม่ต้องคืนสต๊อกที่นี่ เพราะ handleUpdate จะจัดการให้
      // มันจะเปรียบเทียบ formDetailList ใหม่กับข้อมูลเก่าใน DB แล้วคืนให้อัตโนมัติ

      // ถ้าเป็น Project → ลบ BOM ลูกทั้งหมดด้วย
      let updatedList = [...formDetailList];
      if (itemToRemove.isProjectItem) {
        const projectItemId = itemToRemove.itemId;

        // ลบหัวโปรเจค + ลูก BOM + Spec ที่ผูกกับ parent นี้
        updatedList = updatedList.filter((item, i) => {
          if (i === index) return false;
          const isChildBOM = (item.itemCode === "BOM" || item.isBOMChild === true) && item.parentId === projectItemId;
          const isSpecOfParent = item.isSpecRow === true && item.parentId === projectItemId;
          return !isChildBOM && !isSpecOfParent;
        });
      } else {
        // ลบรายการทั่วไป + แถว Spec ของรายการนั้น (ถ้ามี)
        updatedList = updatedList.filter((item, i) => {
          if (i === index) return false;
          const isSpecOfThis = item.isSpecRow === true && item.parentId === itemToRemove.itemId;
          return !isSpecOfThis;
        });
      }

      console.log("ลบรายการสำเร็จ, จำนวนรายการคงเหลือ:", updatedList.length);
      setFormDetailList(updatedList);
    } catch (error) {
      console.error("handleRemoveRow error:", error);
      getAlert("FAILED", "เกิดข้อผิดพลาดในการลบรายการ: " + error.message);
    }
  };

  const handleVatChange = () => {
    setIsVatChecked((prev) => !prev);
  };

  // SET WAREHOUSE
  const [showWarehouseModal, setShowWarehouseModal] = useState(false);
  const handleWarehouseShow = () => setShowWarehouseModal(true);
  const handleWarehouseClose = () => setShowWarehouseModal(false);
  const onRowSelectWh = async (whSelected) => {
    // สำหรับ Freeze หน้าจอตอนทำรายการ
    setIsLoading(true);

    handleWarehouseClose();

    if (formDetailList && formDetailList.length > 0) {
      for (let index = 0; index < formDetailList.length; index++) {
        handleChangeDetail(index, "whId", whSelected.WH_Id);
      }
    } else {
      setIsLoading(false);
      getAlert("FAILED", "กรุณาเลือกสินค้าก่อน");
    }

    setIsLoading(false);
  };

  const checkPayment = async () => {
    const totalPaidAmount =
      (paymentType.cash ? parseCurrency(paymentAmount.cash) : 0) +
      (paymentType.transfer ? parseCurrency(paymentAmount.transfer) : 0) +
      (paymentType.cheque ? parseCurrency(paymentAmount.cheque) : 0) +
      (paymentType.credit ? parseCurrency(paymentAmount.credit) : 0) +
      (paymentType.unpaid ? parseCurrency(paymentAmount.unpaid) : 0);

    if (parseCurrency(totalPaidAmount) === 0) {
      getAlert("FAILED", "กรุณาระบุยอดการชำระเงิน");
      setIsLoading(false);
      return;
    }

    // if (parseCurrency(totalPaidAmount) > parseCurrency(grandTotal)) {
    //   getAlert("FAILED", "กรุณาระบุยอดการชำระเงินไม่เกินกว่าที่ต้องชำระเงิน");
    //   setIsLoading(false);
    //   return;
    // }

    await setShowConfirmModal(true);
  };

  // การคำนวณยอดรวม (totalPrice)
  useEffect(() => {
    const total = formDetailList.reduce(
      (acc, item) => acc + (parseCurrency(item.itemTotal) || 0),
      0
    );
    setTotalPrice(total);
  }, [formDetailList]);

  // การคำนวณส่วนลด (receiptDiscount)
  useEffect(() => {
    let discountValue = parseCurrency(formMasterList.discountValue || 0);
    let receiptDiscount = 0;

    if (selectedDiscountValueType === "2") {
      // เปอร์เซ็นต์
      receiptDiscount = (totalPrice / 100) * discountValue;
    } else if (selectedDiscountValueType === "1") {
      // จำนวนเงิน
      receiptDiscount = discountValue;
    }

    setReceiptDiscount(receiptDiscount);
  }, [totalPrice, formMasterList.discountValue, selectedDiscountValueType]);

  // การคำนวณยอดหลังหักส่วนลด (subFinal)
  useEffect(() => {
    const subFinal = totalPrice - receiptDiscount;
    setSubFinal(subFinal);
  }, [totalPrice, receiptDiscount]);

  // การคำนวณ VAT (vatAmount)
  useEffect(() => {
    const vat = isVatChecked ? subFinal * 0.07 : 0;
    setVatAmount(parseCurrency(vat.toFixed(2)));
  }, [subFinal, isVatChecked]);

  // การคำนวณยอดรวมทั้งสิ้น (grandTotal)
  useEffect(() => {
    const grandTotal = subFinal + vatAmount;
    setGrandTotal(parseCurrency(grandTotal));
  }, [subFinal, vatAmount]);

  return (
    <>
      <div
        hidden={
          window.location.pathname === "/bill" ||
          window.location.pathname === "/picking-list"
        }
      >
        <Breadcrumbs
          page={mode === "U" ? maxDocNo : displayDocNo}
          isShowStatus={mode === "U"}
          statusName={statusTransportName}
          statusColour={statusTransportColour}
          otherStatusName={statusPaidName}
          otherStatusColour={statusPaidColour}
          otherTypeName={statusPaidTypeName}
          otherTypeColour={statusPaidTypeColour}
          items={[
            { name: "งานบัญชี", url: "/account" },
            { name: name, url: "/invoice" },
            {
              name: mode === "U" ? "เรียกดู" + name : "สร้าง" + name,
              url: "#",
            },
          ]}
          docIsINV={formMasterList.docIsInv}
          docRec={formMasterList.docInvNo}
          onHandleClick={() => getReport("so", formMasterList.docNo)}
          onHandlePayslip={() => getReport("rc", formMasterList.docNo)}
          onHandleInvoice1={() => getReport("inv1", formMasterList.docInvNo)}
          onHandleInvoice2={() => getReport("inv2", formMasterList.docInvNo)}
          onHandleInvoice3={() => getReport("so_receipt", formMasterList.docNo)}
          urlImg={formMasterList.docPaidPic}
          handleUploadSlip={handleUploadSlip}
          base64Image={base64Image}
          setBase64Image={setBase64Image}
          handleUpdateSlip={handleUpdateSlip}
          docInvNo={formMasterList.docInvNo}
          isVatChecked={isVatChecked}
        />
      </div>

      {/* Loading Spinner */}
      {isLoading && (
        <div
          className="position-fixed top-0 start-0 w-100 h-100 bg-dark bg-opacity-50 d-flex justify-content-center align-items-center"
          style={{ zIndex: 9999 }}
        >
          <div className="spinner-border text-light" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        </div>
      )}

      <div className="hidden-scrollbar" style={{ overflowY: "auto" }}>
        <div className="row mt-1">
          <div className="col-3 text-left">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสาร</label>
              <Datetime
                className="input-spacing-input-date"
                name="docDate"
                value={formMasterList.docDate || null}
                onChange={(date) => handleChangeDateMaster(date, "docDate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled: formMasterList.docStatusPaid === 3,
                }}
              />
            </div>
          </div>
          <div className="col-4 text-left">
            <div className="d-flex align-items-center">
              <label>ลูกค้า</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="apCode"
                  value={
                    (formMasterList.arCode || "") +
                    " " +
                    (formMasterList.arName || "")
                  }
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleArShow}
                  disabled={formMasterList.docStatusPaid === 3 ? true : false}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
            </div>
            <ArModal
              showArModal={showArModal}
              handleArClose={handleArClose}
              arDataList={arDataList}
              onRowSelectAr={onRowSelectAr}
            />
          </div>
          <div className="col-2"></div>
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdDate"
                value={formMasterList.createdDate}
                // onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>อ้างอิงเอกสาร</label>
              <div className="input-group">
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="refDoc"
                  value={formMasterList.refDoc || ""}
                  onChange={handleChangeMaster}
                  disabled={true}
                />
                <button
                  className="btn btn-outline-secondary"
                  onClick={handleQtShow}
                  disabled={formMasterList.docStatusPaid === 3}
                >
                  <i className="fas fa-search"></i>
                </button>
              </div>
              <QtModal
                showQtModal={showQtModal}
                handleQtClose={handleQtClose}
                qtDataList={qtDataList}
                onRowSelectQt={onRowSelectQt}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>ที่อยู่</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="arAdd1"
                placeholder="ที่อยู่บรรทัดที่ 1"
                value={formMasterList.arAdd1 || ""}
                onChange={(e) => handleAddressChange('arAdd1', e.target.value)}
                disabled={formMasterList.docStatusPaid === 3}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้สร้างเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="createdByName"
                value={formMasterList.createdByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่เอกสารอ้างอิง</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="refDocDate"
                value={formMasterList.refDocDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                name="arAdd2"
                placeholder="ที่อยู่บรรทัดที่ 2"
                value={formMasterList.arAdd2 || ""}
                onChange={(e) => handleAddressChange('arAdd2', e.target.value)}
                disabled={formMasterList.docStatusPaid === 3}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>วันที่แก้ไขล่าสุด</label>
              <input
                // type="date"
                type="text"
                className="form-control input-spacing"
                name="updateDate"
                value={formMasterList.updateDate || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>ประเภทเอกสาร</label>
              <select
                className="form-select form-control input-spacing"
                name="docType"
                value={formMasterList.docType}
                onChange={handleChangeMaster}
                disabled={formMasterList.docStatusPaid === 3}
              >
                {tbDocType.map((docType) => (
                  <option key={docType.DocType_Id} value={docType.DocType_Id}>
                    {docType.DocType_Name}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label></label>
              <input
                type="text"
                className="form-control input-spacing"
                name="arAdd3"
                placeholder="ที่อยู่บรรทัดที่ 3"
                value={formMasterList.arAdd3 || ""}
                onChange={(e) => handleAddressChange('arAdd3', e.target.value)}
                disabled={formMasterList.docStatusPaid === 3}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right">
            <div className="d-flex align-items-center">
              <label>ผู้แก้ไขเอกสาร</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="updateByName"
                value={formMasterList.updateByName || ""}
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
        </div>

        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>วัตถุประสงค์</label>
            <select
              name="docFor"
              value={formMasterList.docFor}
              onChange={handleChangeMaster}
              className="form-select form-control input-spacing"
              disabled={
                formMasterList.docStatusPaid === 3 ||
                  window.location.pathname === "/bill"
                  ? true
                  : false
              }
            >
              <option value="1">ซื้อมาเพื่อใช้</option>
              <option value="2">ซื้อมาเพื่อขาย</option>
            </select>
          </div> */}
            <div className="d-flex align-items-center">
              <label>วันครบกำหนด</label>
              <Datetime
                className="input-spacing-input-date"
                name="doc_due_date"
                value={formatThaiDateUi(formMasterList.doc_due_date) || null}
                onChange={(date) =>
                  handleChangeDateMaster(date, "doc_due_date")
                }
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled: formMasterList.docStatusPaid === 3,
                }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>เลขที่ภาษี</label>
              <input
                type="text"
                className="form-control input-spacing"
                value={formMasterList.arTaxNo || ""}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 ">
            <div className="d-flex align-items-center">
              <label>พนักงานขาย</label>
              {/* <input
                type="text"
                className="form-control input-spacing"
                name="saleName"
                onChange={handleChangeMaster}
                value={formMasterList.saleName || ""}
                disabled={false}
              /> */}
              <div className="w-100">
                <Select
                  name="saleName"
                  options={options}
                  value={
                    options.find((opt) => opt.label.includes(formMasterList.saleName)) || null
                  }
                  placeholder={formMasterList.saleName}
                  onChange={(selectedOption) =>
                    handleChangeMaster({
                      target: {
                        name: "saleName",
                        value: selectedOption ? selectedOption.label.replace(/^(คุณ|นาย)\s*/, "") : "",
                      },
                    })
                  }
                  isDisabled={!saleman || saleman.length === 0}
                />

              </div>
            </div>
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            {/* <div className="d-flex align-items-center">
            <label>Due Date</label>
            <Datetime
              className="input-spacing-input-date"
              name="docDueDate"
              value={formMasterList.docDueDate || null}
              onChange={(date) => handleChangeDateMaster(date, "docDueDate")}
              dateFormat="DD-MM-YYYY"
              timeFormat={false}
              inputProps={{
                readOnly: true,
                disabled:
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false,
              }}
            />
          </div> */}
          </div>
          <div className="col-6" />
          <div className="col-3 text-right">
            {/* <div className="d-flex align-items-center">
            <label>ผู้อนุมัติเอกสาร</label>
            <input
              type="text"
              className="form-control input-spacing"
              name="approvedByName"
              value={formMasterList.approvedByName || ""}
              onChange={handleChangeMaster}
              disabled={true}
            />
          </div> */}
          </div>
        </div>
        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วิธีจัดส่ง</label>
              <select
                name="transportType"
                value={formMasterList.transportType}
                onChange={handleChangeMaster}
                className="form-select form-control input-spacing"
                disabled={
                  formMasterList.docStatusPaid === 3 ||
                    window.location.pathname === "/bill"
                    ? true
                    : false
                }
              >
                {tbTransType.map((transType) => (
                  <option
                    key={transType.Trans_TypeID}
                    value={transType.Trans_TypeID}
                  >
                    {transType.Trans_TypeName}
                  </option>
                ))}
              </select>
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>อ้างอิงใบสั่งซื้อ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="refBillNo"
                onChange={handleChangeMaster}
                value={formMasterList.refBillNo || ""}
                disabled={false}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 text-right" />
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>วันที่กำหนดส่ง</label>
              <Datetime
                className="input-spacing-input-date"
                name="dateSend"
                value={formatThaiDateUi(formMasterList.dateSend) || null}
                onChange={(date) => handleChangeDateMaster(date, "dateSend")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled: formMasterList.docStatusPaid === 3,
                }}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label>วันที่ใบสั่งซื้อ</label>
              <Datetime
                className="input-spacing-input-date"
                name="refBilldate"
                value={formMasterList.refBilldate || null}
                onChange={(date) => handleChangeDateMaster(date, "refBilldate")}
                dateFormat="DD-MM-YYYY"
                timeFormat={false}
                inputProps={{
                  readOnly: true,
                  disabled: formMasterList.docStatusPaid === 3,
                }}
              />
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 " />
        </div>

        <div className="row mt-1">
          <div className="col-3">
            <div className="d-flex align-items-center">
              <label>เงื่อนไขการชำระ</label>
              <input
                type="text"
                className="form-control input-spacing"
                name="credit_Term"
                value={
                  formMasterList.credit === true
                    ? `เครดิต ${formMasterList.credit_Term} วัน`
                    : formMasterList.credit === false
                      ? "เงินสด"
                      : ""
                }
                onChange={handleChangeMaster}
                disabled={true}
              />
            </div>
          </div>
          <div className="col-4">
            <div className="d-flex align-items-center">
              <label
                style={{
                  alignSelf: "self-start",
                  marginTop: "15px",
                }}
              >
                สถานที่ส่งของ
              </label>
              <div className="w-100">
                {transportList.length > 0 && (
                  <select
                    className="form-control input-spacing my-1"
                    value="-1"
                    onChange={(e) => {
                      const idx = e.target.value;
                      if (idx === "-1") return;
                      const selectedDelivery = transportList[idx];

                      const tel1 =
                        selectedDelivery.Tel1 && selectedDelivery.Contact1
                          ? `${selectedDelivery.Tel1} (${selectedDelivery.Contact1})`
                          : selectedDelivery.Tel1
                            ? selectedDelivery.Tel1
                            : selectedDelivery.Contact1
                              ? `(${selectedDelivery.Contact1})`
                              : "";

                      const tel2 =
                        selectedDelivery.Tel2 && selectedDelivery.Contact2
                          ? `${selectedDelivery.Tel2} (${selectedDelivery.Contact2})`
                          : selectedDelivery.Tel2
                            ? selectedDelivery.Tel2
                            : selectedDelivery.Contact2
                              ? `(${selectedDelivery.Contact2})`
                              : "";

                      const telCombined = [tel1, tel2].filter((t) => t).join(" / ");

                      setFormMasterList((prev) => ({
                        ...prev,
                        placeDelivery: `${selectedDelivery.Add1 || ""}`.trim(),
                        placeDelivery2: `${selectedDelivery.Add2 || ""}`.trim(),
                        placeDelivery3: `${selectedDelivery.Add3 || ""} ${selectedDelivery.Province || ""} ${selectedDelivery.Zip_Code || ""} ${telCombined}`.trim(),
                      }));
                    }}
                  >
                    <option value="-1" disabled>-- เลือกที่อยู่จัดส่ง --</option>
                    {transportList.map((item, idx) => {
                      const label = `${item.Add1 || ""} ${item.Add2 || ""} ${item.Add3 || ""}`.trim();
                      return (
                        <option key={idx} value={idx}>
                          {label}
                        </option>
                      );
                    })}
                  </select>
                )}

                <input
                  type="text"
                  className="form-control input-spacing"
                  name="placeDelivery"
                  placeholder="ที่อยู่จัดส่งบรรทัดที่ 1"
                  value={formMasterList.placeDelivery || ""}
                  onChange={(e) => handleDeliveryAddressChange('placeDelivery', e.target.value)}
                  disabled={formMasterList.docStatusPaid === 3}
                />

                <input
                  type="text"
                  className="form-control input-spacing"
                  name="placeDelivery2"
                  placeholder="ที่อยู่จัดส่งบรรทัดที่ 2"
                  value={formMasterList.placeDelivery2 || ""}
                  onChange={(e) => handleDeliveryAddressChange('placeDelivery2', e.target.value)}
                  disabled={formMasterList.docStatusPaid === 3}
                />
                <input
                  type="text"
                  className="form-control input-spacing"
                  name="placeDelivery3"
                  placeholder="ที่อยู่จัดส่งบรรทัดที่ 3"
                  value={formMasterList.placeDelivery3 || ""}
                  onChange={(e) => handleDeliveryAddressChange('placeDelivery3', e.target.value)}
                  disabled={formMasterList.docStatusPaid === 3}
                />

              </div>
            </div>
          </div>
          <div className="col-2" />
          <div className="col-3 " />
        </div>

        <hr />
        <div className="row mt-2">
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>รายละเอียดเอกสาร</label>
              <textarea
                type="text"
                className=" input-spacing"
                name="docRemark1"
                value={formMasterList.docRemark1 || ""}
                onChange={handleChangeMaster}
                style={{ height: "65px" }}
              // disabled={formMasterList.docStatus !== 1}
              />
            </div>
          </div>
          <div className="col-6">
            <div className="d-flex align-items-center">
              <label>หมายเหตุธุรการ</label>
              <textarea
                type="text"
                className="input-spacing"
                name="docRemark2"
                value={formMasterList.docRemark2 || ""}
                onChange={handleChangeMaster}
                // maxLength={500}
                style={{ height: "65px" }}

              // disabled={
              //   formMasterList.docStatusPaid === 3 ||
              //   window.location.pathname === "/bill"
              //     ? true
              //     : false
              // }
              />
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <ItemTable
            formDetailList={formDetailList}
            setFormDetailList={setFormDetailList}
            handleChangeDetail={handleChangeDetail}
            handleDuplicateRow={handleDuplicateRow}
            handleRemoveRow={handleRemoveRow}
            formatCurrency={formatCurrency}
            showItemModal={showItemModal}
            handleItemClose={handleItemClose}
            itemDataList={itemDataList}
            onRowSelectItem={onRowSelectItem}
            onRowSelectItem02={(selectedItems) =>
              onRowSelectItem02(selectedItems)
            }
            handleItemShow={handleItemShow}
            whDataList={whDataList}
            showWarehouseModal={showWarehouseModal}
            handleWarehouseClose={handleWarehouseClose}
            handleWarehouseShow={handleWarehouseShow}
            onRowSelectWh={onRowSelectWh}
            handleFocus={handleFocus}
            handleBlur={handleBlur}
            disabled={formMasterList.docStatusPaid === 3}
            onRowSelectItemForEdit={onRowSelectItemForEdit}
          />
          <Summary
            formMasterList={formMasterList}
            handleChangeMaster={handleChangeMaster}
            selectedDiscountValueType={selectedDiscountValueType}
            handleCheckboxChange={handleCheckboxChange}
            receiptDiscount={receiptDiscount}
            formatCurrency={formatCurrency}
            totalPrice={totalPrice}
            subFinal={subFinal}
            isVatChecked={isVatChecked}
            handleVatChange={handleVatChange}
            vatAmount={vatAmount}
            grandTotal={grandTotal}
            disabled={
              formMasterList.docStatusPaid === 3 ||
                window.location.pathname === "/bill"
                ? true
                : false
            }
            disabledVat={mode === "U"}
          />
          <div
            hidden={
              window.location.pathname === "/bill" ||
              window.location.pathname === "/picking-list"
            }
          >
            <PaymentModal
              mode={mode}
              show={showPayTypeModal}
              grandTotal={grandTotal}
              paymentType={paymentType}
              setPaymentType={setPaymentType}
              paymentAmount={paymentAmount}
              setPaymentAmount={setPaymentAmount}
              handlePayTypeClose={handlePayTypeClose}
              handleUpdatePayment={handleUpdatePayment}
              handleUploadSlip={handleUploadSlip}
              base64Image={base64Image}
              setBase64Image={setBase64Image}
              chequeNo={chequeNo}
              setChequeNo={setChequeNo}
              chequeName={chequeName}
              setChequeName={setChequeName}
              chequeBranch={chequeBranch}
              setChequeBranch={setChequeBranch}
              showConfirmModal={showConfirmModal}
              setShowConfirmModal={setShowConfirmModal}
              checkPayment={checkPayment}
            />
          </div>
        </div>
      </div>
      <FormAction
        onSubmit={async () => {
          if (
            parseCurrency(grandTotal) === 0 &&
            formMasterList.arItemFree === "N"
          ) {
            getAlert("FAILED", "กรุณาเพิ่มรายการ หรือ ใส่จำนวนเงินก่อนบันทึก");
            return;
          }

          if (!formMasterList.arID || !formMasterList.arCode) {
            getAlert("FAILED", "กรุณาเลือกลูกค้า");
            return;
          }

          if (!formDetailList || formDetailList.length === 0) {
            getAlert("FAILED", "กรุณาเพิ่มรายละเอียดสินค้า");
            return;
          }

          for (const item of formDetailList) {
            // ข้าม Spec row (ไม่ต้องตรวจสอบ)
            if (item.isSpecRow) continue;

            if (!item.itemQty || parseCurrency(item.itemQty) === 0) {
              getAlert("FAILED", `กรุณากรอกจำนวนของสินค้า ${item.itemName}`);
              return;
            }
            if (
              formMasterList.arItemFree === "N" &&
              (!item.itemPriceUnit || parseCurrency(item.itemPriceUnit) === 0)
            ) {
              getAlert("FAILED", `กรุณากรอกราคาของสินค้า ${item.itemName}`);
              return;
            }
            if (!item.whId) {
              getAlert("FAILED", `ไม่พบคลังสินค้าของ ${item.itemName}`);
              return;
            }

            if (
              !item.isProjectItem &&
              parseCurrency(item.itemQty) > parseCurrency(item.itemOnHand)
            ) {
              const shouldContinue = await new Promise((resolve) => {
                getAlert(
                  "C_DIALOG",
                  `จำนวนสินค้า ${item.itemName} ไม่พอ กรุณายืนยันว่าต้องการดำเนินการต่อหรือไม่`,
                  (isConfirm) => resolve(isConfirm)
                );
              });

              if (!shouldContinue) {
                return;
              }
            }
          }


          const isDuplicate =
            await checkDuplicateCutStockByCustomerAndProject();

          if (isDuplicate) {
            // ถ้าซ้ำ ไม่ต้องตัดสต๊อก บันทึกเลย
            setFormMasterList((prev) => ({
              ...prev,
              isCutSTC: "N",
              isCutSTC_INVno: null,
            }));

            // บันทึกทันที โดยส่งค่า isCutStock = "N" และ outStock = 0
            if (formMasterList.arItemFree === "Y") {
              await handleSubmit(0, 0, 0, "N", 0);
            } else {
              await handleSubmit(2, 5, grandTotal, "N", 0);
            }
          } else {
            // ถ้าไม่ซ้ำ แสดง dialog ถามก่อน
            getAlert("C_DIALOG", "คุณต้องการตัดสต๊อกหรือไม่?", async (isConfirm) => {
              console.debug("Dialog callback received:", { isConfirm });

              // isConfirm = true (ตัดสต็อก = 1), false (ไม่ตัดสต็อก = 0)
              // ไม่มีกรณียกเลิก ต้องเลือกอย่างใดอย่างหนึ่ง
              const outStock = isConfirm ? 1 : 0; // 1 = ตัดสต็อก, 0 = ไม่ตัดสต็อก
              const cutStock = isConfirm ? "Y" : "N";

              console.debug("Calculated values:", { outStock, cutStock });

              setFormMasterList((prev) => ({
                ...prev,
                isCutSTC: cutStock,
                isCutSTC_INVno: null,
              }));

              // บันทึกทันที โดยส่งค่า isCutStock และ outStock เข้าไป
              if (formMasterList.arItemFree === "Y") {
                await handleSubmit(0, 0, 0, cutStock, outStock);
              } else {
                await handleSubmit(2, 5, grandTotal, cutStock, outStock);
              }
            });
          }
        }}
        onUpdate={async () => {
          // ถามก่อนว่าจะตัดสต๊อกหรือไม่
          getAlert("C_DIALOG", "คุณต้องการตัดสต๊อกหรือไม่?", async (isConfirm) => {
            console.debug("Update Dialog callback received:", { isConfirm });

            const shouldCutStock = isConfirm; // true = ตัดสต๊อก, false = ไม่ตัดสต๊อก

            console.debug("shouldCutStock:", shouldCutStock);

            // เรียก handleUpdate พร้อมส่งค่า shouldCutStock
            await handleUpdate(shouldCutStock);
          });
        }}
        onCancel={handleCancel}
        onApprovedPay={handlePayTypeShow}
        onUpdatePaid={handleUpdatePaidStatus}
        docStatus={formMasterList.docStatusPaid}
        mode={mode}
        disabled={false}
        disabledInv={formMasterList.docIsInv === "Y" ? true : false}
        disabledPay={isBl}
        creditCustomer={paymentType.credit}
        footer={true}
      />

      {/* Confirm Modal */}
      <div
        className={`modal fade ${showConfirmModal ? "show" : ""}`}
        tabIndex="-1"
        style={{ display: showConfirmModal ? "block" : "none" }}
      >
        <div className="modal-dialog modal-dialog-centered" role="document">
          <div className="modal-content">
            <div className="modal-header">
              <h5 className="modal-title fw-bold">ยืนยันการบันทึก</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => setShowConfirmModal(false)}
                aria-label="Close"
              ></button>
            </div>
            <div className="modal-body">
              <p>คุณแน่ใจว่าต้องการบันทึกข้อมูลใบกำกับภาษีหรือไม่?</p>
            </div>
            <div className="modal-footer">
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white d-flex align-items-center justify-content-center"
                style={{ backgroundColor: "#EF6C00", fontSize: "16px" }}
                onClick={async () => {
                  setShowConfirmModal(false);
                  if (formMasterList?.arItemFree === "Y") {
                    await handleSubmit(0, 0, 0);
                    // await callInitialize();
                    // getAlert("OK", "บันทึกข้อมูลใบขายสำเร็จ");
                  } else {
                    await handleUpdatePayment();
                  }
                }}
                disabled={isSubmitting}
              >
                ยืนยัน
              </button>
              <button
                type="button"
                className="btn btn-lg w-25 shadow text-white"
                style={{ backgroundColor: "red", fontSize: "16px" }}
                onClick={() => setShowConfirmModal(false)}
                disabled={isSubmitting}
              >
                ยกเลิก
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
export default Form;
